// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-01T16:13:25.943Z
// Property: Tilian Point (ID: 6767906449167750)
// Collections: 31 amenities, 4 floorplans (live), 68 photos, 79 POIs, 4 reviews, 3 virtual tours, 4 office hours, 1 special offers (live), 24 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162471",
  "multihub_property_id": "6767906449167750",
  "property_external_id": "hefb3w3",
  "property_zillow_url": "https://www.zillow.com/apartments/woodburn-or/tilian-point/Ck3sC6/",
  "property_apartments_url": "https://www.apartments.com/tilian-point-woodburn-or/hefb3w3/",
  "property_google_business_url": "https://www.google.com/maps/place/Tilian+Point/@45.1549409,-122.8816853,807m/data=!3m2!1e3!4b1!4m6!3m5!1s0x54955dede1e8181b:0xeb50f8304d230372!8m2!3d45.1549409!4d-122.8816853!16s%2Fg%2F11w4k_qrp1?entry=ttu&g_ep=EgoyMDI2MDgzMC4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "30257379884",
  "property_crm_software": "EliseAI",
  "property_pm_software": "Resman",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "tilian-point",
  "property_name": "Tilian Point",
  "property_website_url": "https://www.tilianpoint.com/",
  "property_domain": "https://www.tilianpoint.com/",
  "property_address": "2385 Sprague Ln",
  "property_full_address": "2385 Sprague Ln, Woodburn, OR 97071",
  "property_address_1": "2385 Sprague Ln",
  "property_address_2": null,
  "property_address_city": "Woodburn",
  "property_address_state": "OR",
  "property_address_zip_full": null,
  "property_address_zip": "97071",
  "property_address_country": "US",
  "property_address_county": "Marion County",
  "property_neighborhood_address": "North Marion County",
  "property_address_latitude": "45.1558289",
  "property_address_longitude": "-122.8815044",
  "property_email": null,
  "property_phone": "(503) 594-4925",
  "property_call_tracking_phone": "5419068171",
  "property_company_name": "Cobalt",
  "property_company_url": "https://cobaltbuilt.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Modern comfort in the heart of Woodburn.</strong> Tilian Point pairs polished one-, two-, and three-bedroom apartments with everyday ease near I-5 and Woodburn Premium Outlets, plus inviting community spaces designed for work, recharge, and time outdoors.</p>",
  "property_long_description": "<p><strong>Modern comfort in the heart of Woodburn.</strong> At Tilian Point, you’re surrounded by everyday ease: Woodburn Premium Outlets sits just across the way, I-5 access is minutes from home, and the Willamette Valley puts Salem, Portland, and wine-country weekends within reach. Choose from one-, two-, and three-bedroom <a href=\"/floor-plans\">apartment layouts</a> with the details that make daily life feel polished, including air conditioning, in-home laundry, dishwashers, soft-close cabinetry, under-cabinet lighting, wood-style flooring, and a private patio or balcony.</p><p>Beyond your front door, the community brings fresh ways to recharge with a fitness center, clubhouse coffee bar, hammock lounge, dog park, basketball and pickleball court, plus an outdoor grill and fire pit. When you’re ready to get out, explore Centennial Park, Downtown Plaza events, Woodburn Public Library, Safeway, Walmart, Starbucks, TopWire Hop Project, and Bauman’s Farm and Garden. See more nearby highlights on the <a href=\"/neighborhood\">neighborhood page</a>, then take a closer look at Tilian Point’s <a href=\"/amenities\">amenities</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-af0d-734d-bccd-5bb6e4d2db2d.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of apartment buildings with RV parking, carports, and surrounding landscape.",
    "public_id": "01a05871-af0d-734d-bccd-5bb6e4d2db2d",
    "storage_key": "property/6767906449167750/01a05871-af0d-734d-bccd-5bb6e4d2db2d.webp",
    "width": 3072,
    "height": 1726
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "72",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "86.11111111111111",
  "property_admin_fee": null,
  "property_application_fee": "45",
  "property_fees_deposit_info": "- $500 if approved as is.\n-$1000 if approved conditionally.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": "500",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "We allow up to 2 pets per home. Breed restrictions apply.",
  "property_pet_policy_description": "We allow up to 2 pets per home. Pet deposit: $300 for the first pet and $500 for the second. Monthly pet rent: $35 per pet. Breed restrictions apply. Assistance and service animals are exempt from all fees and deposits.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://myrentalapplication.com/index/tilianpoint",
  "property_resident_portal_url": "https://neighborlyventures.myresman.com/Portal/Access/SignIn/TP",
  "property_apply_now_url": "https://myrentalapplication.com/index/tilianpoint",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831e-b84a-7058-8119-24bfe6ef3a0d.webp",
  "property_primary_logo_media": {
    "alt_text": "Tilian Point logo",
    "public_id": "01a0831e-b84a-7058-8119-24bfe6ef3a0d",
    "storage_key": "property/6767906449167750/01a0831e-b84a-7058-8119-24bfe6ef3a0d.webp",
    "width": 300,
    "height": 72
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831e-b8ec-74ed-8e65-cebf0bd7e90f.webp",
  "property_secondary_logo_media": {
    "alt_text": "Tilian Point Apartment Homes logo",
    "public_id": "01a0831e-b8ec-74ed-8e65-cebf0bd7e90f",
    "storage_key": "property/6767906449167750/01a0831e-b8ec-74ed-8e65-cebf0bd7e90f.webp",
    "width": 1000,
    "height": 982
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-a7f4-778b-8684-208098feb78c.webp",
  "property_icon_media": {
    "alt_text": "Property management company logo with purple and green stripes forming a square.",
    "public_id": "01a05871-a7f4-778b-8684-208098feb78c",
    "storage_key": "property/6767906449167750/01a05871-a7f4-778b-8684-208098feb78c.webp",
    "width": 910,
    "height": 910
  },
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05e35-9e0a-77e8-9dda-a20d0de41c82.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a05e35-9e0a-77e8-9dda-a20d0de41c82",
    "storage_key": "property/6767906449167750/01a05e35-9e0a-77e8-9dda-a20d0de41c82.webp",
    "width": 845,
    "height": 192
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05e35-939d-75fe-8068-77da36d3b5c0.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a05e35-939d-75fe-8068-77da36d3b5c0",
    "storage_key": "property/6767906449167750/01a05e35-939d-75fe-8068-77da36d3b5c0.webp",
    "width": 845,
    "height": 192
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162471/01a0c9e6-767d-7068-bfd2-02c98e18a059.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162471/01a0ca52-f30f-7748-a6da-18b1abb45f57.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#254084",
  "property_secondary_color": "#4b1f5d",
  "property_font_color": null,
  "property_color_4": "#4b6a33",
  "property_color_3": "#c0c430",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "667 - 1,210 sq ft",
  "property_sqft_min": "667",
  "property_sqft_max": "1,210",
  "property_price_range": "$1343 - $1955",
  "property_price_min": "1343",
  "property_price_max": "1955",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/TilianPointApartments",
  "property_instagram_url": "https://www.instagram.com/tilianpointapartments",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJGxjo4e1dlVQRcgMjTTD4UOs",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Tilian Point",
  "property_home_romance_title": "Create Cherished Memories in Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Downtime comes with options at Tilian Point.</strong> Work out in the fitness center, play on the basketball and pickleball court, unwind in the hammock lounge, or gather by the outdoor grill and fire pit. A clubhouse with a complimentary coffee bar adds everyday ease, while apartment features like in-home laundry, air conditioning, soft-close cabinetry, under-cabinet lighting, wood-style flooring, and a private patio or balcony keep home feeling polished.</p>",
  "property_home_floorplans_blurb": "<p><strong>Space, style, and everyday ease.</strong> Explore one-, two-, and three-bedroom apartments in Woodburn with open-concept layouts, in-home washer and dryer, and a private patio or balcony. Modern finishes like wood-style flooring, soft-close cabinets, under-cabinet lighting, and well-equipped kitchens keep each home polished and practical, while select plans add details like vaulted ceilings or a built-in desk.</p>",
  "property_home_gallery_blurb": "<p><strong>Take a closer look at Tilian Point.</strong> Preview bright open living rooms, granite countertops, stainless steel appliances, wood-style flooring, and private patios or balconies. Then picture more of the community: a clubhouse lounge, fitness center, hammock lawn, sport court, dog park, outdoor grill, and fire pit—all with an easygoing Woodburn feel that comes through in every photo.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Woodburn days start close to home.</strong> Browse the outlets across Sprague Lane, grab coffee or groceries nearby, or head toward Downtown Plaza for seasonal events and local stops. For more open sky, explore Willamette Valley favorites like Wooden Shoe Tulip Farm, TopWire Hop Project, and nearby parks—all with I-5, Woodburn Transit, and Cherriots routes close at hand.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents are talking about the ease of life at Tilian Point.</strong> Reviews point to bright, spacious apartments, helpful support from Hannah and the team, and smooth tours and move-ins. Community favorites include the welcoming clubhouse, EV charging, outdoor spaces, and walking trail, plus a Woodburn location close to shopping and freeway access. Read more to see why Tilian Point earns such easy recommendations.</p>",
  "property_neighborhood_blurb": "<p><strong>Map out a Woodburn day from Tilian Point.</strong> Start with outlet browsing just across Sprague Lane, pick up groceries or coffee on the way home, then follow the map toward Downtown Plaza for seasonal events and small-town stops. When you want more open sky, Woodburn’s Willamette Valley setting puts tulip fields at Wooden Shoe Tulip Farm, hop-country afternoons at TopWire Hop Project, and nearby parks within easy reach.</p><p>Commuting and weekend exploring feel simple, too: I-5 is close by, Woodburn Transit Service serves the city, and Cherriots regional routes connect Woodburn with Salem-area destinations. Use the interactive map to find your next favorite table, trail, errand run, or quick route—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Tilian Point fits into the neighborhood.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that make downtime feel easy.</strong> At Tilian Point, your day can shift from movement to relaxation without leaving the community. Get in a workout at the fitness center, meet up on the basketball and pickleball court, take a quieter pause in the hammock lounge, or settle in by the outdoor grill and fire pit. A clubhouse with a complimentary coffee bar adds an easy stop to your morning routine, while the dog park gives four-legged residents a dedicated place to stretch out.</p><p>Inside your Woodburn apartment, modern finishes keep everyday tasks simple and polished. In-home laundry, air conditioning, a dishwasher, soft-close cabinetry, under-cabinet lighting, wood-style flooring, and a private patio or balcony all work together to create a home that feels considered from the start. Explore available <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the spaces in person.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Tilian Point.</strong> Modern one-, two-, and three-bedroom apartments pair polished finishes with everyday convenience in the heart of Woodburn. With I-5 minutes away and community spaces designed for easy downtime, your next home is ready when you are. Apply online today.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Connect with the Tilian Point leasing team for help exploring modern one-, two-, and three-bedroom apartments in Woodburn, just minutes from I-5. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Tilian Point?</strong> Start here for quick answers about the community, leasing, amenities, and everyday apartment living in Woodburn. If you don’t see what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your day.</strong> Tilian Point’s one-, two-, and three-bedroom apartments give you room to settle in, spread out, and choose the setup that works best for your routines in Woodburn. Browse open-concept floor plans with everyday conveniences already built in, from an in-home washer and dryer to a private patio or balcony that extends your living space outdoors.</p><p>Inside, polished finishes make each home feel fresh without feeling fussy: wood-style flooring, soft-close cabinets, under-cabinet lighting, and well-equipped kitchens create a clean, modern backdrop for how you live. Select homes may also include features like vaulted ceilings or a built-in desk, so check current availability and compare details as you explore. When a plan catches your eye, <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_gallery_blurb": "<p><strong>See Tilian Point in detail.</strong> Browse the gallery for a closer look at the spaces that shape each day: bright open living rooms, modern kitchens with granite countertops and stainless steel appliances, and bedrooms that feel calm and uncluttered. Notice the wood-style flooring, the bar seating, the natural light, and the private patios or balconies that extend your space outdoors.</p><p>Then look beyond the front door. Photos reveal the clubhouse lounge, sunny dining areas, the fitness center, hammock lawn, sport court, dog park, and outdoor grill and fire pit—all framed by the easygoing feel of this Woodburn community. When a photo catches your eye, explore the <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Tilian Point in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Tilian Point on the map.</strong> See available apartments in Woodburn and get a feel for the surrounding area, from shopping across the way to quick I-5 access and Willamette Valley destinations within reach.</p>",
  "property_pets_blurb": "<p><strong>A home that keeps pet routines simple.</strong> At Tilian Point, you can head to the on-site dog park for fresh air close to your door, then come back to an apartment designed for everyday ease with durable vinyl flooring, in-home laundry, and storage for leashes, carriers, toys, and treats.</p><p>Whether your day includes a quick walk, a sunny pause on your patio or balcony, or a trip to the city’s largest dog park, this pet-friendly Woodburn community helps make life with your companion feel more convenient. Review the policy details below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the spaces for yourself.</p>",
  "property_referafriend_blurb": "<p><strong>Share the everyday ease of Tilian Point.</strong> Invite a friend to discover modern Woodburn apartments with polished in-home finishes, private outdoor space, and comfortable community spots for recharging. Send a referral today and help them picture life just minutes from I-5 and local conveniences.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Tilian Point.</strong><br>Keep daily life moving with quick online tools to pay rent, submit maintenance requests, and manage your account—all from your modern Woodburn apartment home.</p>",
  "property_reviews_blurb": "<p><strong>Hear it from the people who know Tilian Point.</strong> Reviews highlight spacious, bright apartments, approachable support from Hannah and the team, and community spaces that make everyday life easier. One reviewer called the apartments “beautiful and spacious,” while others praised the helpful tour experience and smooth move-in support.</p><p>You’ll also see residents call out the details that stand out after a visit or move-in: a welcoming clubhouse for gatherings, EV charging, outdoor places to relax, and a walking trail. The location earns consistent praise, too, with convenient access to shopping and the freeway. Browse the reviews below to see what makes Tilian Point feel easy to recommend.</p>",
  "property_created_at": "1788190187254",
  "property_scheduletour_blurb": "<p><strong>See Tilian Point up close.</strong> Tour modern one-, two-, and three-bedroom apartments with polished finishes like in-home laundry, soft-close cabinetry, wood-style flooring, and private outdoor space—then picture the fitness center, clubhouse coffee bar, hammock lounge, and courts as part of your everyday rhythm.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we received your inquiry.</strong><br>The Tilian Point leasing team will be in touch soon. In the meantime, picture modern Woodburn comfort with polished apartment finishes, easy I-5 access, and inviting community spaces designed for everyday recharge. Explore our <a href=\"/floor-plans\">floor plans</a> or take a closer look at the <a href=\"/amenities\">amenities</a>.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you arrive.</strong> Tilian Point’s virtual tours let you move through the spaces at your own pace, from the 1-bedroom Unit A304 to the 3-bedroom Unit B312 and the 360 Amenities Tour. Start in the apartment interiors to see open living areas, modern kitchens with stainless steel appliances, in-home laundry, and the private patio or balcony connection that brings in extra breathing room.</p><p>Then explore the community tour for a fuller sense of the setting, including shared spaces designed for movement, lounging, and everyday convenience. Compare what you see with current <a href=\"/floor-plans\">floor plan options</a>, browse the <a href=\"/gallery\">photo gallery</a> for more angles, or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to experience Tilian Point in Woodburn in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Tilian Point",
  "property_seo_title_home": "Apartments for Rent in Woodburn, OR | Tilian Point",
  "property_seo_description_home": "Apartments for rent in Woodburn, OR with in-home washer/dryer, granite countertops, and a dog park, across from Woodburn Premium Outlets. Tour Tilian Point.",
  "property_seo_title_floorplans": "1, 2 & 3 Bedroom Apartments in Woodburn, OR | Tilian Point",
  "property_seo_description_floorplans": "View 1-, 2-, and 3-bedroom floor plans at Tilian Point in Woodburn, OR. Every home includes granite countertops, in-home washer/dryer, and a private patio or balcony.",
  "property_seo_title_amenities": "Apartment Amenities in Woodburn, OR | Tilian Point",
  "property_seo_description_amenities": "Tilian Point in Woodburn, OR includes a fitness center, dog park, pickleball court, hammock lounge, clubhouse & pet-friendly apartments in Woodburn.",
  "property_seo_title_gallery": "Gallery | Apartments in Woodburn, OR",
  "property_seo_description_gallery": "Capture the essence of Tilian Point in Woodburn, OR. Experience vibrant living with modern amenities and stunning spaces. Picture your life here!",
  "property_seo_title_virtualtours": "Virtual Tours | Tilian Point Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Tilian Point in Woodburn, OR. Take a virtual tour of our spacious one, two, and three-bedroom apartments—your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Tilian Point Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Tilian Point in Woodburn, OR! Enjoy spacious 1-3 bedroom apartments with fantastic amenities. Check out our interactive map now!",
  "property_seo_title_neighborhood": "Woodburn, OR Neighborhood Near Centennial Park | Tilian Point",
  "property_seo_description_neighborhood": "Tilian Point is across from Woodburn Premium Outlets, 0.3 miles from Centennial Park, and minutes from I-5. Explore life in Woodburn, OR. Schedule a tour.",
  "property_seo_title_contact": "Contact Us | Tilian Point",
  "property_seo_description_contact": "Connect with Tilian Point in Woodburn, OR! Whether you need info on one, two, or three-bedroom designs, our leasing team is ready to help you today!",
  "property_seo_title_faqs": "FAQs | Tilian Point Apartments in Woodburn, OR",
  "property_seo_description_faqs": "Got questions about Tilian Point in Woodburn, OR? Find answers about floor plans, pet policy, amenities, parking, and more — or call us at 971-406-2535.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Woodburn, OR",
  "property_seo_description_reviews": "Experience life at Tilian Point in Woodburn, OR! Check out our residents' rave reviews about our vibrant community and fantastic amenities. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Woodburn, OR",
  "property_seo_description_applynow": "Experience luxury living at Tilian Point in Woodburn, OR. Enjoy spacious floor plans, modern amenities, and a vibrant community. Secure your spot online today!",
  "property_seo_title_residentaccess": "Resident Access | Tilian Point",
  "property_seo_description_residentaccess": "Log in to your Tilian Point resident portal for easy rent payments, maintenance requests, and community updates. Simplify your living experience today!",
  "property_seo_title_referafriend": "Refer A Friend | Tilian Point",
  "property_seo_description_referafriend": "Refer a friend to Tilian Point in Woodburn, OR! Great neighbors start with great friends—share the joy of apartment living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Tilian Point",
  "property_seo_description_scheduletour": "Experience the charm of Tilian Point in Woodburn, OR. Schedule a tour today and envision your new beginning in our welcoming apartment community!",
  "property_seo_title_privacy": "Privacy Policy | Tilian Point",
  "property_seo_description_privacy": "At Tilian Point in Woodburn, OR, your privacy matters. Uncover how we protect your data in our privacy policy. Trust us for a secure living experience!",
  "property_seo_title_accessibility": "Website Accessibility | Tilian Point",
  "property_seo_description_accessibility": "At Tilian Point in Woodburn, OR, we prioritize digital inclusion with features that ensure a seamless living experience for everyone. Join us!",
  "property_seo_title_sitemap": "Sitemap | Tilian Point",
  "property_seo_description_sitemap": "Navigate Tilian Point in Woodburn, OR, with ease! Check out our sitemap to find your way to luxurious living and discover all our community has to offer.",
  "property_seo_title_thankyou": "Thank You | Tilian Point",
  "property_seo_description_thankyou": "Thank you for your interest in Tilian Point! Our team will reach out soon to help you find your perfect home in beautiful Woodburn, OR. Stay connected!",
  "property_seo_title_pets": "Pet Policy | Apartments in Woodburn, OR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790871144116",
  "amenities": [
    {
      "id": "custom_11cf93a4-6316-4a5c-bd45-9f626cfc9b00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse with Lounge Seating and Kitchen",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4ae59b30-6199-4558-8406-4be45eec714a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Complimentary Coffee Bar",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fbb71af7-532b-4a34-a54a-d5b4935e35ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center with Cardio and Free Weights",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f3398202-191f-4aa1-bdb9-91409bc08c28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Basketball & Pickleball Court",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_feb9f811-6774-426e-b19b-a1f5608124c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Grill & Picnic Area",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d6b421e9-d972-4e34-bf38-ce016518dc18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Fire Pit",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ddb70214-1aa7-44ee-9a81-187878735e89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Hammock Lounge",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f7d5153a-d3b0-41ee-a1fc-0aa691827eed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Community Garden",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b4807c67-86db-45ac-8137-b6cd8eaa64cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Dog Park",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_743ab07b-2ab7-4f25-b00f-9141940132a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Carport Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1a028845-7297-44cb-8047-e4c682fad69f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "EV Charging",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_de2a48eb-95e6-4207-a2ca-c37e936794b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Walking Trails",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c66bb43c-56c0-4ee5-bc8f-03f6714c55ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management Team",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_63f72949-72ee-4bd7-8455-9d73500a4866",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b682eeea-096f-432a-aa40-8a5ae36b3d30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Steps from Woodburn Premium Outlets",
      "amount": "false",
      "description": "",
      "group": "Community Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ad6739c4-8e6d-4a4d-a96a-1b43f934026c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "Apartment Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8b12cc90-99d5-45ee-a708-9e33945b5e4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_99df432a-8497-490b-8cce-3aae5cfc767b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "In-Home Washer & Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_27f505b2-71ca-4f98-8351-6260a640aafb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Soft-Close Cabinets",
      "amount": "false",
      "description": "",
      "group": "Apartment Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b2837e17-ad92-4f71-9197-3a2dcf5b3519",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Under-Cabinet Lighting",
      "amount": "false",
      "description": "",
      "group": "Apartment Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1a47c209-88a8-418a-9eb9-1655b878b41c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fce46e5f-9d90-4803-a34a-90809390d510",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Wood-Style Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_12b25b87-1ee9-4208-ab0f-ac31be784a68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6a4d84fd-3a2a-4230-a82f-5939e9c9983e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_892301c9-8206-4c60-9f1e-b4c4b5727e48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Soft-Close Cabinets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d6be6651-d9b3-4ec1-8838-b065f373247e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fe057e47-60fb-4850-8f6a-0e675c2e4640",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d130512a-99fb-435b-b8fc-9970d5c3020f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a4c61777-a239-40b3-8064-e409777dd44b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8297dc56-0ca3-426a-897a-1640a74e00c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Under-Cabinet Lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b254c084-10f4-4828-9737-2a777b28a1a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "external_id": "false",
      "title": "Wood-Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_30811f6b-7764-490f-8fbb-b547eecc3c99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-c567-7159-88b5-d1b16fe1424f.webp",
      "image_media": {
        "alt_text": "Outdoor covered pavilion with seating, grills, and a TV.",
        "public_id": "01a0831c-c567-7159-88b5-d1b16fe1424f",
        "storage_key": "property/6767906449167750/01a0831c-c567-7159-88b5-d1b16fe1424f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our outdoor amenities, including a covered pavilion with seating, grills, and entertainment, perfect for gatherings.",
      "link": "",
      "alt_text": "Outdoor covered pavilion with seating, grills, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cf4fceec-ed04-4ee7-a0e1-7aec0acc62f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-c3c6-70dd-8d74-d27f9074a541.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with covered parking and balconies.",
        "public_id": "01a0831c-c3c6-70dd-8d74-d27f9074a541",
        "storage_key": "property/6767906449167750/01a0831c-c3c6-70dd-8d74-d27f9074a541.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment complex exterior featuring balconies, covered parking, and well-maintained landscaping.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with covered parking and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_72c407a8-8afb-40de-82a6-e0ee4c7777d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-b892-74e8-af20-96e03363d522.webp",
      "image_media": {
        "alt_text": "Tilian Point apartment building exterior with a basketball court and signage.",
        "public_id": "01a0831c-b892-74e8-af20-96e03363d522",
        "storage_key": "property/6767906449167750/01a0831c-b892-74e8-af20-96e03363d522.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover Tilian Point apartments, featuring a basketball court for residents, and offering new 1-3 bedroom apartments for rent.",
      "link": "",
      "alt_text": "Tilian Point apartment building exterior with a basketball court and signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7a105bbb-1c7f-4c1a-84d7-b253ec2d8316",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-beb2-75d0-837d-0dabb0cbfad2.webp",
      "image_media": {
        "alt_text": "Exterior of an apartment building with covered parking and balconies.",
        "public_id": "01a0831c-beb2-75d0-837d-0dabb0cbfad2",
        "storage_key": "property/6767906449167750/01a0831c-beb2-75d0-837d-0dabb0cbfad2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring private balconies and convenient covered parking spaces.",
      "link": "",
      "alt_text": "Exterior of an apartment building with covered parking and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fecdff8a-bba0-4839-8eaf-78151f282196",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-ae67-759b-a8ff-f389eb3f4ce9.webp",
      "image_media": {
        "alt_text": "Exterior hallway with multiple apartment doors, a fire extinguisher, and exterior lighting.",
        "public_id": "01a0831c-ae67-759b-a8ff-f389eb3f4ce9",
        "storage_key": "property/6767906449167750/01a0831c-ae67-759b-a8ff-f389eb3f4ce9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior hallway leading to apartment entrances, featuring well-maintained siding, exterior lighting, and safety equipment like a fire extinguisher for resident peace of mind.",
      "link": "",
      "alt_text": "Exterior hallway with multiple apartment doors, a fire extinguisher, and exterior lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5a825c35-c326-43dd-bea7-a1b055d6211d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-a855-71f9-b042-554454d9ae41.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet, ceiling fan, and blinds-covered window.",
        "public_id": "01a0831c-a855-71f9-b042-554454d9ae41",
        "storage_key": "property/6767906449167750/01a0831c-a855-71f9-b042-554454d9ae41.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A bright and airy bedroom featuring neutral tones, plush carpeting, a ceiling fan for comfort, and a large window with blinds.",
      "link": "",
      "alt_text": "Empty bedroom with carpet, ceiling fan, and blinds-covered window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_71b7e48d-cb78-4d67-9471-24cb6c7cace7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-a26f-775d-91b6-16fb8f118abf.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer and view into bathroom with toilet and tub.",
        "public_id": "01a0831c-a26f-775d-91b6-16fb8f118abf",
        "storage_key": "property/6767906449167750/01a0831c-a26f-775d-91b6-16fb8f118abf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "In-unit laundry with stacked washer and dryer, adjacent to a full bathroom with toilet and tub.",
      "link": "",
      "alt_text": "Stacked washer and dryer and view into bathroom with toilet and tub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_36bc6f9e-62fa-4da2-b1c1-6011d2736c62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-9e77-704c-a73b-415cd1bf3c7b.webp",
      "image_media": {
        "alt_text": "View from a balcony overlooking a residential community with buildings and green spaces.",
        "public_id": "01a0831c-9e77-704c-a73b-415cd1bf3c7b",
        "storage_key": "property/6767906449167750/01a0831c-9e77-704c-a73b-415cd1bf3c7b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the scenic views from your private balcony, overlooking the community's well-maintained grounds and surrounding landscape.",
      "link": "",
      "alt_text": "View from a balcony overlooking a residential community with buildings and green spaces.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9b4615ee-6229-4b9d-8955-e878f784365c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-9071-70ba-88f3-70e2faf77f8c.webp",
      "image_media": {
        "alt_text": "Bedroom with gray walls and a closet with sliding doors.",
        "public_id": "01a0831c-9071-70ba-88f3-70e2faf77f8c",
        "storage_key": "property/6767906449167750/01a0831c-9071-70ba-88f3-70e2faf77f8c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring plush gray carpeting, neutral walls, and ample storage with a large closet. The adjacent kitchen is visible through the doorway.",
      "link": "",
      "alt_text": "Bedroom with gray walls and a closet with sliding doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_921d59f8-ce09-48fb-a16d-bf4a24d5b930",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-926a-707a-8fba-9d07cfbf8d1c.webp",
      "image_media": {
        "alt_text": "View from balcony overlooking undeveloped land and apartment buildings.",
        "public_id": "01a0831c-926a-707a-8fba-9d07cfbf8d1c",
        "storage_key": "property/6767906449167750/01a0831c-926a-707a-8fba-9d07cfbf8d1c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the serene views from your private balcony overlooking the natural landscape and surrounding community amenities.",
      "link": "",
      "alt_text": "View from balcony overlooking undeveloped land and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b931dabc-0f2a-4f4e-91ab-bd2286233e83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-9061-7663-90c2-befa983c446b.webp",
      "image_media": {
        "alt_text": "View of apartment buildings and a grassy courtyard with a walking path.",
        "public_id": "01a0831c-9061-7663-90c2-befa983c446b",
        "storage_key": "property/6767906449167750/01a0831c-9061-7663-90c2-befa983c446b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience modern living in our spacious apartment community, featuring beautiful grounds and convenient walking paths for residents to enjoy.",
      "link": "",
      "alt_text": "View of apartment buildings and a grassy courtyard with a walking path.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_037eb8eb-e257-4ea0-b487-07384c2404f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-813a-7603-9177-2e1065c21e29.webp",
      "image_media": {
        "alt_text": "Spacious living area with a view of the modern kitchen.",
        "public_id": "01a0831c-813a-7603-9177-2e1065c21e29",
        "storage_key": "property/6767906449167750/01a0831c-813a-7603-9177-2e1065c21e29.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Open-concept living space flowing into a fully equipped kitchen with stainless steel appliances and ample cabinet storage.",
      "link": "",
      "alt_text": "Spacious living area with a view of the modern kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_18659da8-c6a1-4826-8655-a57363b91a10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-86ce-7376-8329-88e2507bba69.webp",
      "image_media": {
        "alt_text": "Dog park area with wood chips and fencing, adjacent to apartment building.",
        "public_id": "01a0831c-86ce-7376-8329-88e2507bba69",
        "storage_key": "property/6767906449167750/01a0831c-86ce-7376-8329-88e2507bba69.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, a safe and fun space for your furry friends to play and socialize within our community.",
      "link": "",
      "alt_text": "Dog park area with wood chips and fencing, adjacent to apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c141332-7384-41bc-abec-0b3fe246c9a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-79ee-705f-9fe4-0c11de3798f3.webp",
      "image_media": {
        "alt_text": "Covered parking lot with a building and hammocks in the background.",
        "public_id": "01a0831c-79ee-705f-9fe4-0c11de3798f3",
        "storage_key": "property/6767906449167750/01a0831c-79ee-705f-9fe4-0c11de3798f3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Covered parking spaces available for residents, with a welcoming building and relaxing hammocks visible in the background.",
      "link": "",
      "alt_text": "Covered parking lot with a building and hammocks in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_788d8fcf-29db-4420-bf77-4af05dd5200e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-867c-75f3-bb35-300ff2bc9cb6.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with fenced pet area and bench.",
        "public_id": "01a0831c-867c-75f3-bb35-300ff2bc9cb6",
        "storage_key": "property/6767906449167750/01a0831c-867c-75f3-bb35-300ff2bc9cb6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors at this apartment complex, featuring a dedicated pet relief area with comfortable seating and walking paths.",
      "link": "",
      "alt_text": "Exterior view of apartment building with fenced pet area and bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bcf252f1-7807-4eae-986c-ea0592fb203a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-7d68-74fa-85ac-a3cad1071142.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and wood floors.",
        "public_id": "01a0831c-7d68-74fa-85ac-a3cad1071142",
        "storage_key": "property/6767906449167750/01a0831c-7d68-74fa-85ac-a3cad1071142.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring ample white cabinetry, a stainless steel refrigerator, oven, microwave, and dishwasher. Finished with sleek countertops and warm wood flooring.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and wood floors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_03f5d4fe-f0ca-4ba0-8084-fab2973804c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-707b-775e-bd7b-e5b38c8871e4.webp",
      "image_media": {
        "alt_text": "Two hanging egg chairs with cushions on a patch of green turf with a parking lot and apartment buildings in the background.",
        "public_id": "01a0831c-707b-775e-bd7b-e5b38c8871e4",
        "storage_key": "property/6767906449167750/01a0831c-707b-775e-bd7b-e5b38c8871e4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable hanging egg chairs, perfect for enjoying the outdoors. Located in a prime community spot with convenient parking and nearby apartment buildings.",
      "link": "",
      "alt_text": "Two hanging egg chairs with cushions on a patch of green turf with a parking lot and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_77230c41-d6b4-49f1-8e65-6c1f9b07e3f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-647f-744d-af0c-4513c835a0c5.webp",
      "image_media": {
        "alt_text": "Covered outdoor patio with seating, tables, and TV.",
        "public_id": "01a0831c-647f-744d-af0c-4513c835a0c5",
        "storage_key": "property/6767906449167750/01a0831c-647f-744d-af0c-4513c835a0c5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy relaxing or entertaining in our spacious outdoor patio area, complete with comfortable seating, tables, and a mounted television.",
      "link": "",
      "alt_text": "Covered outdoor patio with seating, tables, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9b2292ea-5089-4382-8cc5-0acc5de2c45b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-5e9c-7311-922f-a28802ef51b4.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with hanging chairs, hammocks, and covered parking.",
        "public_id": "01a0831c-5e9c-7311-922f-a28802ef51b4",
        "storage_key": "property/6767906449167750/01a0831c-5e9c-7311-922f-a28802ef51b4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our outdoor lounge area, featuring comfortable hanging chairs and hammocks, with convenient covered parking available.",
      "link": "",
      "alt_text": "Outdoor lounge area with hanging chairs, hammocks, and covered parking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_df377b83-fd55-4a53-80fe-a5e835cdcb78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-5ab1-701e-83c9-a3b24cc0da02.webp",
      "image_media": {
        "alt_text": "Covered outdoor patio with seating, bar area, and TV.",
        "public_id": "01a0831c-5ab1-701e-83c9-a3b24cc0da02",
        "storage_key": "property/6767906449167750/01a0831c-5ab1-701e-83c9-a3b24cc0da02.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living on the covered patio, complete with a full-service bar, comfortable seating, and entertainment.",
      "link": "",
      "alt_text": "Covered outdoor patio with seating, bar area, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_088a20eb-5e60-4366-9adc-df4ae5ad0a18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-6063-71dd-b6af-7463206f6950.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with hammocks and hanging chairs near apartment buildings.",
        "public_id": "01a0831c-6063-71dd-b6af-7463206f6950",
        "storage_key": "property/6767906449167750/01a0831c-6063-71dd-b6af-7463206f6950.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in the community's outdoor seating area, featuring comfortable hammocks and unique hanging chairs. Perfect for enjoying the fresh air and scenic views.",
      "link": "",
      "alt_text": "Outdoor seating area with hammocks and hanging chairs near apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cdd5c884-7872-4c0e-804f-4bc36180ee34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-4f83-717c-99d4-4c71f02ebdfc.webp",
      "image_media": {
        "alt_text": "Outdoor fire pit and seating area with covered pavilion and grilling station.",
        "public_id": "01a0831c-4f83-717c-99d4-4c71f02ebdfc",
        "storage_key": "property/6767906449167750/01a0831c-4f83-717c-99d4-4c71f02ebdfc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather around the fire pit or enjoy the covered outdoor pavilion and grilling station, perfect for community events and relaxation.",
      "link": "",
      "alt_text": "Outdoor fire pit and seating area with covered pavilion and grilling station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c5fc1001-3be9-486c-98d5-700a23104aea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-51e6-729a-a7ce-241f0d06c3c0.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with tables, chairs, fire pit, and grills.",
        "public_id": "01a0831c-51e6-729a-a7ce-241f0d06c3c0",
        "storage_key": "property/6767906449167750/01a0831c-51e6-729a-a7ce-241f0d06c3c0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors in our community lounge area, featuring comfortable seating, a fire pit, and grills for your convenience.",
      "link": "",
      "alt_text": "Outdoor lounge area with tables, chairs, fire pit, and grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b8620ae9-9feb-419f-873f-1dee44cff64a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-4a0c-72d8-973b-fc929a461983.webp",
      "image_media": {
        "alt_text": "Outdoor covered patio with high-top tables, bar stools, and grills.",
        "public_id": "01a0831c-4a0c-72d8-973b-fc929a461983",
        "storage_key": "property/6767906449167750/01a0831c-4a0c-72d8-973b-fc929a461983.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at our covered patio, complete with high-top seating, bar stools, and barbecue grills. Perfect for socializing and dining al fresco.",
      "link": "",
      "alt_text": "Outdoor covered patio with high-top tables, bar stools, and grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e4b2e657-de43-463e-bd05-116fa11f3a06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-4bb7-7003-8d18-7ebee1618ecc.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with fire pit, seating, covered pavilion with tables, and grills.",
        "public_id": "01a0831c-4bb7-7003-8d18-7ebee1618ecc",
        "storage_key": "property/6767906449167750/01a0831c-4bb7-7003-8d18-7ebee1618ecc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed outdoor patio area, complete with a fire pit, comfortable seating, and a covered pavilion featuring dining tables and grills.",
      "link": "",
      "alt_text": "Outdoor patio area with fire pit, seating, covered pavilion with tables, and grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0d23aafd-2027-44d9-bfbb-d4339013efd2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-4d0d-73df-be6d-750678a5dd08.webp",
      "image_media": {
        "alt_text": "Built-in stainless steel grill with stone accents under a covered patio.",
        "public_id": "01a0831c-4d0d-73df-be6d-750678a5dd08",
        "storage_key": "property/6767906449167750/01a0831c-4d0d-73df-be6d-750678a5dd08.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with this high-end, built-in stainless steel grill, perfect for community gatherings and BBQs.",
      "link": "",
      "alt_text": "Built-in stainless steel grill with stone accents under a covered patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_67b2b242-e7b6-424f-b7f5-ce0cf6767c43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-4211-7255-b287-03ea9710d79c.webp",
      "image_media": {
        "alt_text": "Dumbbells on a rack in a gym.",
        "public_id": "01a0831c-4211-7255-b287-03ea9710d79c",
        "storage_key": "property/6767906449167750/01a0831c-4211-7255-b287-03ea9710d79c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "A rack of dumbbells in a gym. Weights are on three shelves and vary in size.",
      "link": "",
      "alt_text": "Dumbbells on a rack in a gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_13027c1e-77c4-4a6b-b6ca-4806a5d84957",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-1d03-73ff-aa4e-808264228db8.webp",
      "image_media": {
        "alt_text": "Modern lounge area with purple sofas, a fireplace, and large windows.",
        "public_id": "01a0831c-1d03-73ff-aa4e-808264228db8",
        "storage_key": "property/6767906449167750/01a0831c-1d03-73ff-aa4e-808264228db8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax in the stylish community lounge, featuring comfortable seating, a modern fireplace, and abundant natural light.",
      "link": "",
      "alt_text": "Modern lounge area with purple sofas, a fireplace, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_45c3cb4d-a9be-49c5-9f63-47618c3032cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-2153-701d-9ed5-61060ba529fe.webp",
      "image_media": {
        "alt_text": "Community kitchen area with a large dining table and chairs, and a modern kitchen with blue cabinets.",
        "public_id": "01a0831c-2153-701d-9ed5-61060ba529fe",
        "storage_key": "property/6767906449167750/01a0831c-2153-701d-9ed5-61060ba529fe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in this stylish community kitchen, perfect for events or casual get-togethers.",
      "link": "",
      "alt_text": "Community kitchen area with a large dining table and chairs, and a modern kitchen with blue cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e151166c-e43c-45b5-83ea-1a51ea465ce1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-1beb-705f-863e-2398042ae4ff.webp",
      "image_media": {
        "alt_text": "Community lounge with purple sofas, fireplace, TV, and kitchen area.",
        "public_id": "01a0831c-1beb-705f-863e-2398042ae4ff",
        "storage_key": "property/6767906449167750/01a0831c-1beb-705f-863e-2398042ae4ff.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, a modern fireplace, and a convenient kitchen area.",
      "link": "",
      "alt_text": "Community lounge with purple sofas, fireplace, TV, and kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_82cf8b0d-8f97-4a7c-bbb2-60014912ce03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-19fa-77a8-833f-287db1f3dd44.webp",
      "image_media": {
        "alt_text": "Large dining table with chairs in a communal kitchen area with a refrigerator and counter space.",
        "public_id": "01a0831c-19fa-77a8-833f-287db1f3dd44",
        "storage_key": "property/6767906449167750/01a0831c-19fa-77a8-833f-287db1f3dd44.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy meals and gatherings in our spacious communal kitchen and dining area, fully equipped for your convenience.",
      "link": "",
      "alt_text": "Large dining table with chairs in a communal kitchen area with a refrigerator and counter space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_05b379c3-cf08-48a0-af0c-34a1700c4b27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-193a-763b-88e7-c8a5bd7e2742.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with surrounding commercial spaces and RV park.",
        "public_id": "01a0831c-193a-763b-88e7-c8a5bd7e2742",
        "storage_key": "property/6767906449167750/01a0831c-193a-763b-88e7-c8a5bd7e2742.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Experience community living with convenient access to shopping and entertainment. This aerial view showcases the apartment buildings, nearby retail centers, and a dedicated RV park.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with surrounding commercial spaces and RV park.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6573a9c2-9e42-4b04-b48e-75ffa423ccd1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-194e-771d-80fe-b7847a951a11.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, weight racks, and exercise equipment.",
        "public_id": "01a0831c-194e-771d-80fe-b7847a951a11",
        "storage_key": "property/6767906449167750/01a0831c-194e-771d-80fe-b7847a951a11.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, weight racks, and a variety of exercise machines.",
      "link": "",
      "alt_text": "Fitness center with treadmills, weight racks, and exercise equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0f992827-ae34-4db3-8202-b60ad2dae1f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-1726-73a8-9b98-b657b8dc058b.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with covered parking.",
        "public_id": "01a0831c-1726-73a8-9b98-b657b8dc058b",
        "storage_key": "property/6767906449167750/01a0831c-1726-73a8-9b98-b657b8dc058b.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Modern apartment building exterior with balconies and covered parking, showcasing the community's amenities.",
      "link": "",
      "alt_text": "Exterior view of apartment building with covered parking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d2a175fe-b7a3-4bb2-983c-4fad13115e77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-193f-7329-b8da-c28b1eb03e30.webp",
      "image_media": {
        "alt_text": "Modern lounge area with purple sectional sofa, large coffee table, and a bar area with stools.",
        "public_id": "01a0831c-193f-7329-b8da-c28b1eb03e30",
        "storage_key": "property/6767906449167750/01a0831c-193f-7329-b8da-c28b1eb03e30.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring comfortable seating, a communal bar, and modern decor.",
      "link": "",
      "alt_text": "Modern lounge area with purple sectional sofa, large coffee table, and a bar area with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1f594325-6f69-4d0b-bbb7-20d20800d20d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-1823-737e-8b49-625353a3c2d6.webp",
      "image_media": {
        "alt_text": "Keurig coffee maker with coffee pods and cups.",
        "public_id": "01a0831c-1823-737e-8b49-625353a3c2d6",
        "storage_key": "property/6767906449167750/01a0831c-1823-737e-8b49-625353a3c2d6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee from our in-unit Keurig coffee maker, stocked with a variety of K-Cups and cups for your convenience.",
      "link": "",
      "alt_text": "Keurig coffee maker with coffee pods and cups.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0b0a2ac6-204d-430a-9cdc-ab5592d27731",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831c-1725-77e7-a069-a7ce1da76997.webp",
      "image_media": {
        "alt_text": "Lobby area with plush purple sofas, a large white coffee table, and bar seating.",
        "public_id": "01a0831c-1725-77e7-a069-a7ce1da76997",
        "storage_key": "property/6767906449167750/01a0831c-1725-77e7-a069-a7ce1da76997.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully designed lobby, featuring comfortable seating and a communal bar area.",
      "link": "",
      "alt_text": "Lobby area with plush purple sofas, a large white coffee table, and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_04058755-b359-46ec-9002-2c5b77012db5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831b-9581-74aa-8d43-89c59623dfd2.webp",
      "image_media": {
        "alt_text": "Exterior of an Adidas store with parking lot in front.",
        "public_id": "01a0831b-9581-74aa-8d43-89c59623dfd2",
        "storage_key": "property/6767906449167750/01a0831b-9581-74aa-8d43-89c59623dfd2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "The exterior of an Adidas retail store with its logo above the entrance. The parking lot in front is clean and well-maintained.",
      "link": "",
      "alt_text": "Exterior of an Adidas store with parking lot in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1e591f70-a81a-44aa-b1bf-156a6d86c28f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831b-912c-740e-b677-35214917b4aa.webp",
      "image_media": {
        "alt_text": "Exterior entrance to apartment with white siding and potted plants.",
        "public_id": "01a0831b-912c-740e-b677-35214917b4aa",
        "storage_key": "property/6767906449167750/01a0831b-912c-740e-b677-35214917b4aa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome guests with a charming exterior entrance featuring white siding, decorative potted plants, and a cozy doormat.",
      "link": "",
      "alt_text": "Exterior entrance to apartment with white siding and potted plants.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_70a87032-da8c-4a8e-be91-c57074b5b06d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831b-93da-71e2-a70c-1edc105eaf40.webp",
      "image_media": {
        "alt_text": "Exterior view of a strip mall with Eddie Bauer and Sunglass Hut storefronts.",
        "public_id": "01a0831b-93da-71e2-a70c-1edc105eaf40",
        "storage_key": "property/6767906449167750/01a0831b-93da-71e2-a70c-1edc105eaf40.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Browse the shops at our vibrant community center, featuring popular brands like Eddie Bauer and Sunglass Hut.",
      "link": "",
      "alt_text": "Exterior view of a strip mall with Eddie Bauer and Sunglass Hut storefronts.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_66248639-7000-4dc7-8a29-375f1d5531c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831b-9269-73c9-8e49-07a3a6d56fba.webp",
      "image_media": {
        "alt_text": "Private patio with seating and a plant",
        "public_id": "01a0831b-9269-73c9-8e49-07a3a6d56fba",
        "storage_key": "property/6767906449167750/01a0831b-9269-73c9-8e49-07a3a6d56fba.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your own private patio space with comfortable seating and outdoor ambiance.",
      "link": "",
      "alt_text": "Private patio with seating and a plant",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_633908aa-14c0-4618-8edd-290adaa6d786",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831b-8f8c-739e-8114-b53f0f6dd28f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, toilet, and striped shower curtain.",
        "public_id": "01a0831b-8f8c-739e-8114-b53f0f6dd28f",
        "storage_key": "property/6767906449167750/01a0831b-8f8c-739e-8114-b53f0f6dd28f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed bathroom featuring a sleek white vanity, a modern toilet, and a stylish striped shower curtain, all designed for your comfort.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, toilet, and striped shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e3fc247a-8e58-49fa-8978-7f82e405f134",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831b-9209-762a-8a55-658bb3db25e6.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower with striped curtain.",
        "public_id": "01a0831b-9209-762a-8a55-658bb3db25e6",
        "storage_key": "property/6767906449167750/01a0831b-9209-762a-8a55-658bb3db25e6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this stylish bathroom, featuring a sleek vanity, a clean white toilet, and a shower complemented by a chic striped curtain. A decorative towel and artwork add a personal touch.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and shower with striped curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_da8d42ff-986b-4618-851b-f3bb08fad77f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831b-40b1-707b-988d-95ea63f8fffa.webp",
      "image_media": {
        "alt_text": "EV charging stations in the parking lot with a building in the background.",
        "public_id": "01a0831b-40b1-707b-988d-95ea63f8fffa",
        "storage_key": "property/6767906449167750/01a0831b-40b1-707b-988d-95ea63f8fffa.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Dedicated EV charging stations available for residents, with ample parking and convenient access.",
      "link": "",
      "alt_text": "EV charging stations in the parking lot with a building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fbfaf4a3-a58f-4706-871e-936b585d9ce0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831b-3a95-74b5-a44f-ca463ab97ac5.webp",
      "image_media": {
        "alt_text": "Pet relief area with wood chips and black fencing",
        "public_id": "01a0831b-3a95-74b5-a44f-ca463ab97ac5",
        "storage_key": "property/6767906449167750/01a0831b-3a95-74b5-a44f-ca463ab97ac5.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy our community pet relief area, perfect for your furry friends to stretch their legs and take care of business in a designated, safe space.",
      "link": "",
      "alt_text": "Pet relief area with wood chips and black fencing",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2c9d9c91-af71-4dc0-8762-0c98bfa2b627",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831b-316a-700a-adbc-b043ec58e964.webp",
      "image_media": {
        "alt_text": "Tilian Point dog park with wood chips and black fencing.",
        "public_id": "01a0831b-316a-700a-adbc-b043ec58e964",
        "storage_key": "property/6767906449167750/01a0831b-316a-700a-adbc-b043ec58e964.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "The Tilian Point dog park features a fenced-in area with wood chips and a bench for pet owners.",
      "link": "",
      "alt_text": "Tilian Point dog park with wood chips and black fencing.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ad165f1d-7f71-4012-be96-731e30b0a91a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831b-0e0c-7219-bbcb-6a4fd1da190c.webp",
      "image_media": {
        "alt_text": "Dog waste station with sign, dispenser, and trash can.",
        "public_id": "01a0831b-0e0c-7219-bbcb-6a4fd1da190c",
        "storage_key": "property/6767906449167750/01a0831b-0e0c-7219-bbcb-6a4fd1da190c.webp",
        "width": 2304,
        "height": 3072
      },
      "title": "Community",
      "description": "Conveniently located dog waste station with clear signage and disposal options to keep the community clean and pet-friendly.",
      "link": "",
      "alt_text": "Dog waste station with sign, dispenser, and trash can.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_895cbee7-a1df-4b9c-a2dc-85427e39c0fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831b-0db6-75c8-8b52-6892e9456614.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building with a grassy lawn and covered seating area.",
        "public_id": "01a0831b-0db6-75c8-8b52-6892e9456614",
        "storage_key": "property/6767906449167750/01a0831b-0db6-75c8-8b52-6892e9456614.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Showcases the modern exterior of the apartment building, complete with a well-maintained lawn and a sheltered outdoor gathering space.",
      "link": "",
      "alt_text": "Exterior view of the apartment building with a grassy lawn and covered seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_19e4da6a-e2b2-4627-a4b4-fc19d3424544",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831b-0cf5-762a-a42e-ca70cd52de13.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with a hoop at Tilian Point Apartment Homes.",
        "public_id": "01a0831b-0cf5-762a-a42e-ca70cd52de13",
        "storage_key": "property/6767906449167750/01a0831b-0cf5-762a-a42e-ca70cd52de13.webp",
        "width": 2304,
        "height": 3072
      },
      "title": "Community",
      "description": "Enjoy some outdoor recreation at the basketball court at Tilian Point Apartment Homes. Now leasing!",
      "link": "",
      "alt_text": "Outdoor basketball court with a hoop at Tilian Point Apartment Homes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7f84753f-8ca1-4a1e-9bc1-0c5b63a48e3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831b-206a-765a-8a69-088cd11bea7f.webp",
      "image_media": {
        "alt_text": "Dog park with wood chips, a welcome sign, and a water fountain.",
        "public_id": "01a0831b-206a-765a-8a69-088cd11bea7f",
        "storage_key": "property/6767906449167750/01a0831b-206a-765a-8a69-088cd11bea7f.webp",
        "width": 2304,
        "height": 3072
      },
      "title": "Community",
      "description": "Welcome your furry friends to our on-site dog park, complete with wood chip ground cover and a convenient water fountain for them to stay hydrated.",
      "link": "",
      "alt_text": "Dog park with wood chips, a welcome sign, and a water fountain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_75d562b9-b250-4940-bc2f-992971537c8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831a-f853-72bf-901b-5a593a196a8f.webp",
      "image_media": {
        "alt_text": "Apartment door A105 with welcome mat and potted plants",
        "public_id": "01a0831a-f853-72bf-901b-5a593a196a8f",
        "storage_key": "property/6767906449167750/01a0831a-f853-72bf-901b-5a593a196a8f.webp",
        "width": 2304,
        "height": 3072
      },
      "title": "Community",
      "description": "The entryway to apartment A105 features a dark gray door, a welcome mat that says \"it's good to be home,\" and two tall black planters with lush greenery.",
      "link": "",
      "alt_text": "Apartment door A105 with welcome mat and potted plants",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_43e46da0-5f4a-47ce-a009-f8d0ed5487da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831a-f77c-7668-8860-b1e3f2c2d4ef.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with a modern hoop and clear blue skies.",
        "public_id": "01a0831a-f77c-7668-8860-b1e3f2c2d4ef",
        "storage_key": "property/6767906449167750/01a0831a-f77c-7668-8860-b1e3f2c2d4ef.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy a friendly game on our outdoor basketball court, perfect for staying active and having fun.",
      "link": "",
      "alt_text": "Outdoor basketball court with a modern hoop and clear blue skies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_04534018-b7b2-4755-8eb2-bb80d804b687",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831a-fae6-7609-80f1-2e9a36331757.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and landscaping.",
        "public_id": "01a0831a-fae6-7609-80f1-2e9a36331757",
        "storage_key": "property/6767906449167750/01a0831a-fae6-7609-80f1-2e9a36331757.webp",
        "width": 2304,
        "height": 3072
      },
      "title": "Community",
      "description": "Modern apartment buildings with balconies set against a clear blue sky, featuring fresh landscaping and a walking path.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a0940ee7-b247-4260-9d88-f23250c984d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831a-eea9-7675-8c91-b74f55067c2d.webp",
      "image_media": {
        "alt_text": "Patio area with two chairs and a small table outside an apartment door.",
        "public_id": "01a0831a-eea9-7675-8c91-b74f55067c2d",
        "storage_key": "property/6767906449167750/01a0831a-eea9-7675-8c91-b74f55067c2d.webp",
        "width": 2304,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private patio, furnished with comfortable seating and a side table. An ideal spot to unwind.",
      "link": "",
      "alt_text": "Patio area with two chairs and a small table outside an apartment door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c47cc7b8-675f-445d-9483-c2e63e94376a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831a-e68d-7728-b6db-bc7fc689b79d.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fire pit and covered pavilion.",
        "public_id": "01a0831a-e68d-7728-b6db-bc7fc689b79d",
        "storage_key": "property/6767906449167750/01a0831a-e68d-7728-b6db-bc7fc689b79d.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy the outdoors with comfortable seating around the fire pit, perfect for gathering with friends and family.",
      "link": "",
      "alt_text": "Outdoor seating area with fire pit and covered pavilion.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_263f3ef1-87c2-4d22-8415-dfb988085153",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831a-c967-703b-b5d0-049b9547d8b0.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with Adirondack chairs and a fire pit.",
        "public_id": "01a0831a-c967-703b-b5d0-049b9547d8b0",
        "storage_key": "property/6767906449167750/01a0831a-c967-703b-b5d0-049b9547d8b0.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Relax and unwind in our outdoor lounge area, featuring comfortable seating and a cozy fire pit, perfect for evening gatherings.",
      "link": "",
      "alt_text": "Outdoor seating area with Adirondack chairs and a fire pit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8f918d11-7fa0-4d0a-84ed-6d4ddfa0e52f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831a-c851-715a-8058-3dbd417c59d7.webp",
      "image_media": {
        "alt_text": "Two hanging chairs on green grass with a parking lot and apartment building in the background.",
        "public_id": "01a0831a-c851-715a-8058-3dbd417c59d7",
        "storage_key": "property/6767906449167750/01a0831a-c851-715a-8058-3dbd417c59d7.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Relax in comfort with these unique hanging chairs, perfect for enjoying the fresh air and outdoor ambiance of our community.",
      "link": "",
      "alt_text": "Two hanging chairs on green grass with a parking lot and apartment building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cfb01c39-a287-480b-85a1-a6f1e34f8d89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831a-caf6-71be-b57d-c5c808a9f78e.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, stair climber, free weights, and exercise balls.",
        "public_id": "01a0831a-caf6-71be-b57d-c5c808a9f78e",
        "storage_key": "property/6767906449167750/01a0831a-caf6-71be-b57d-c5c808a9f78e.webp",
        "width": 2304,
        "height": 3072
      },
      "title": "Community",
      "description": "State-of-the-art fitness center equipped with cardio machines, free weights, and exercise balls for a comprehensive workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, stair climber, free weights, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6b4203fe-7518-4d35-a14d-819a89cee383",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0831a-c8a4-72b5-b40a-0ccad9167668.webp",
      "image_media": {
        "alt_text": "Tilian Point logo on a moss wall",
        "public_id": "01a0831a-c8a4-72b5-b40a-0ccad9167668",
        "storage_key": "property/6767906449167750/01a0831a-c8a4-72b5-b40a-0ccad9167668.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Logo",
      "description": "The Tilian Point logo is displayed on a decorative moss wall above a communal workspace with bar stools.",
      "link": "",
      "alt_text": "Tilian Point logo on a moss wall",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_48113a69-0d76-499b-bbda-21ecf398d8af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0cacc-4be0-772e-85d5-df56ca6dbea2.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a spacious laundry closet with shelving.",
        "public_id": "01a0cacc-4be0-772e-85d5-df56ca6dbea2",
        "storage_key": "property/6767906449167750/01a0cacc-4be0-772e-85d5-df56ca6dbea2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer, making laundry day a breeze. Ample shelving provides convenient storage for supplies.",
      "link": "",
      "alt_text": "Washer and dryer in a spacious laundry closet with shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_446b3b0b-ef20-4925-a513-9eeb90fada52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0cacc-28a4-716c-b586-466be4955270.webp",
      "image_media": {
        "alt_text": "Private patio with two chairs, a small table, and a plant.",
        "public_id": "01a0cacc-28a4-716c-b586-466be4955270",
        "storage_key": "property/6767906449167750/01a0cacc-28a4-716c-b586-466be4955270.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your own private patio space with comfortable seating and a touch of greenery. Perfect for morning coffee or evening relaxation.",
      "link": "",
      "alt_text": "Private patio with two chairs, a small table, and a plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5eeb1268-7e81-47ca-a5e5-7d514a47b394",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0cacb-debc-7408-a4ab-461d8c81bbdd.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with white cabinets, stainless steel appliances, and island seating.",
        "public_id": "01a0cacb-debc-7408-a4ab-461d8c81bbdd",
        "storage_key": "property/6767906449167750/01a0cacb-debc-7408-a4ab-461d8c81bbdd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy this open-concept living and kitchen area, perfect for entertaining or relaxing after a long day.",
      "link": "",
      "alt_text": "Modern living room and kitchen with white cabinets, stainless steel appliances, and island seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b05b4384-84fd-47aa-981f-73a310ef283e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0cacb-dd89-7662-948c-94680e2a1025.webp",
      "image_media": {
        "alt_text": "A bright bedroom with a queen-size bed, a nightstand, and a desk.",
        "public_id": "01a0cacb-dd89-7662-948c-94680e2a1025",
        "storage_key": "property/6767906449167750/01a0cacb-dd89-7662-948c-94680e2a1025.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush queen-size bed and a functional workspace.",
      "link": "",
      "alt_text": "A bright bedroom with a queen-size bed, a nightstand, and a desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2c66450d-801f-403e-8d68-c8593e75fc93",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0cacb-c42b-720c-b7bd-88097c235271.webp",
      "image_media": {
        "alt_text": "Living room with a couch, coffee table, two chairs, and a plant.",
        "public_id": "01a0cacb-c42b-720c-b7bd-88097c235271",
        "storage_key": "property/6767906449167750/01a0cacb-c42b-720c-b7bd-88097c235271.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room with modern furniture, featuring a comfortable couch, chic coffee table, and accent chairs. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a couch, coffee table, two chairs, and a plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8b45bdd1-5cca-4fd6-ab9f-84cafa07c698",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0cacb-dfdf-740b-8dd7-21daf9dc82ed.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and quartz countertops.",
        "public_id": "01a0cacb-dfdf-740b-8dd7-21daf9dc82ed",
        "storage_key": "property/6767906449167750/01a0cacb-dfdf-740b-8dd7-21daf9dc82ed.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this sleek, modern kitchen featuring stainless steel appliances, ample cabinet space, and beautiful quartz countertops.",
      "link": "",
      "alt_text": "Modern white kitchen with stainless steel appliances and quartz countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dbc2938f-448d-4493-bba0-a85b64a5b652",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0cacb-c562-71a0-95d8-94e8f8ada77d.webp",
      "image_media": {
        "alt_text": "Bedroom with two twin beds, colorful bedding, and minimalist decor.",
        "public_id": "01a0cacb-c562-71a0-95d8-94e8f8ada77d",
        "storage_key": "property/6767906449167750/01a0cacb-c562-71a0-95d8-94e8f8ada77d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring two twin beds with vibrant, modern bedding. Decorated with minimalist art and a playful rainbow rug.",
      "link": "",
      "alt_text": "Bedroom with two twin beds, colorful bedding, and minimalist decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3f930a6f-7848-4dc4-8e93-d064c5ff50de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0cacb-c17e-7041-a91d-2de531b6aa06.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with island seating and entertainment center.",
        "public_id": "01a0cacb-c17e-7041-a91d-2de531b6aa06",
        "storage_key": "property/6767906449167750/01a0cacb-c17e-7041-a91d-2de531b6aa06.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment living area featuring an open-concept layout with a fully equipped kitchen, comfortable seating, and entertainment space.",
      "link": "",
      "alt_text": "Modern living room and kitchen area with island seating and entertainment center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80ced5ba-62cf-4a98-9317-53f19b168592",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a0cacb-c24a-743d-b3d9-afc43c1363f0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island with a sink.",
        "public_id": "01a0cacb-c24a-743d-b3d9-afc43c1363f0",
        "storage_key": "property/6767906449167750/01a0cacb-c24a-743d-b3d9-afc43c1363f0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A sleek and modern kitchen featuring white cabinetry, stainless steel appliances including a refrigerator, stove, and microwave, ample counter space, and a stylish faucet over the sink. Perfect for culinary enthusiasts.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island with a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_0c915521-54a4-4b54-8453-d4180804e8ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Elmer's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "255 N Arney Rd, Woodburn, OR 97071, USA",
      "poi_short_description": "Restaurant serving hearty portions of breakfast fare plus other comfort food in a diner-style setting.",
      "poi_long_description": "Restaurant serving hearty portions of breakfast fare plus other comfort food in a diner-style setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05870-f84b-70b3-8d4a-41e66fb0a134.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05870-f84b-70b3-8d4a-41e66fb0a134",
        "storage_key": "property/6767906449167750/01a05870-f84b-70b3-8d4a-41e66fb0a134.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://eatatelmers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15401474605450940836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elmers-restaurant",
      "poi_latitude": "45.1530723",
      "poi_longitude": "-122.8821716",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-982-2255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e498-74fd-b135-3cacc582564f",
        "storage_key": "property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6UHf4mlclVQRpFEam40HvdU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_58f83564-b683-48ee-9594-78b1f05bd7c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Red Robin Gourmet Burgers and Brews",
      "poi_type": "Restaurants",
      "poi_address": "3060 Sprague Ln, Woodburn, OR 97071, USA",
      "poi_short_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_long_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05870-f714-7653-828d-0af1b9b93269.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05870-f714-7653-828d-0af1b9b93269",
        "storage_key": "property/6767906449167750/01a05870-f714-7653-828d-0af1b9b93269.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.redrobin.com/locations/or/woodburn/woodburn-531",
      "poi_directions_map_url": "https://maps.google.com/?cid=17959284834831498780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-robin-gourmet-burgers-and-brews",
      "poi_latitude": "45.152807",
      "poi_longitude": "-122.8809492",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-980-1598",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e498-74fd-b135-3cacc582564f",
        "storage_key": "property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH_XuEUNclVQRHP4wqGcyPPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_81a687d3-d33c-4cba-b810-7f62b97260f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "3000 Sprague Ln, Woodburn, OR 97071, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-8f1d-73a9-af63-b229f740cfef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-8f1d-73a9-af63-b229f740cfef",
        "storage_key": "property/6767906449167750/01a05873-8f1d-73a9-af63-b229f740cfef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/or/woodburn/3000-sprague-lane?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=202163&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=4118142498348252322&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "45.153665",
      "poi_longitude": "-122.879528",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-981-0404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c79b-7103-8e7e-e623a5c8eae4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05873-c79b-7103-8e7e-e623a5c8eae4",
        "storage_key": "property/6767906449167750/01a05873-c79b-7103-8e7e-e623a5c8eae4.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJDc_4-QJdlVQRorx8jMiUJjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_faf43793-c6a2-4ebe-8b30-758a56b24edb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Denny's",
      "poi_type": "Restaurants",
      "poi_address": "2919 Tom Tennant Dr, Woodburn, OR 97071, USA",
      "poi_short_description": "Casual diner chain dishing up classic American comfort fare, including all-day breakfast favorites.",
      "poi_long_description": "Casual diner chain dishing up classic American comfort fare, including all-day breakfast favorites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-89fd-712b-a75a-2124d91279ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-89fd-712b-a75a-2124d91279ec",
        "storage_key": "property/6767906449167750/01a05873-89fd-712b-a75a-2124d91279ec.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://locations.dennys.com/OR/WOODBURN/246530?utm_source=yext&utm_medium=local-listing&utm_campaign=yext-listing&y_source=1_MjIyODQ3Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ==",
      "poi_directions_map_url": "https://maps.google.com/?cid=15475539851367313449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dennys",
      "poi_latitude": "45.1521443",
      "poi_longitude": "-122.8778334",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-981-9738",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e498-74fd-b135-3cacc582564f",
        "storage_key": "property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ75JT0BclVQRKXAmfIApxNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_00115e2f-f69e-4786-ad0a-15e7434d2d1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Luis's Taqueria",
      "poi_type": "Restaurants",
      "poi_address": "523 N Front St, Woodburn, OR 97071, USA",
      "poi_short_description": "Casual storefront counter serve offering Michoacán-style tacos, tortas & other Mexican dishes.",
      "poi_long_description": "Casual storefront counter serve offering Michoacán-style tacos, tortas & other Mexican dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05870-fa2c-765b-9367-b0f2a6eb38a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05870-fa2c-765b-9367-b0f2a6eb38a5",
        "storage_key": "property/6767906449167750/01a05870-fa2c-765b-9367-b0f2a6eb38a5.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.luistaqueria.com/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=1e665ee5-353e-418c-8745-6f2c4e177adb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6429953220473082669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "luiss-taqueria",
      "poi_latitude": "45.143615",
      "poi_longitude": "-122.8554404",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-981-8437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e498-74fd-b135-3cacc582564f",
        "storage_key": "property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTeftHiVclVQRLVOt_GLIO1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_9124db74-b586-4f57-8d65-f8a24d6e7097",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Los Cabos Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1565 N Pacific Hwy, Woodburn, OR 97071, USA",
      "poi_short_description": "Casual option for classic Mexican food, such as fajitas and enchiladas, plus margaritas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-8d35-7590-91a3-3157c5d7b7f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-8d35-7590-91a3-3157c5d7b7f8",
        "storage_key": "property/6767906449167750/01a05873-8d35-7590-91a3-3157c5d7b7f8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bit.ly/4apRIud",
      "poi_directions_map_url": "https://maps.google.com/?cid=5967869155166596898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "los-cabos-mexican-restaurant",
      "poi_latitude": "45.1504407",
      "poi_longitude": "-122.8326173",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-982-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e498-74fd-b135-3cacc582564f",
        "storage_key": "property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr2xOj9FdlVQRIi-3o2Ah0lI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_8de043cf-42e7-4524-8228-f98a882b681d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Trapala Brewpub & Rostisseria",
      "poi_type": "Restaurants",
      "poi_address": "152 Garfield St, Woodburn, OR 97071, USA",
      "poi_short_description": "Birria, burritos, and other Mexican plates dished up in relaxed environs with beer and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-89bf-77cc-9389-2219599cca20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-89bf-77cc-9389-2219599cca20",
        "storage_key": "property/6767906449167750/01a05873-89bf-77cc-9389-2219599cca20.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9369770361482964414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trapala-brewpub--rostisseria",
      "poi_latitude": "45.14240909999999",
      "poi_longitude": "-122.8574552",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-982-4614",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e498-74fd-b135-3cacc582564f",
        "storage_key": "property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAyoJjiRclVQRvu0sJ4AcCII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_884ca3f5-d4b8-4e14-b60f-f6d00a7fa587",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Casa De Caldos",
      "poi_type": "Restaurants",
      "poi_address": "954 N Pacific Hwy, Woodburn, OR 97071, USA",
      "poi_short_description": "Caldo-focused joint serving Oaxacan-style Mexican dishes, plus breakfast and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-8ae2-70ae-9550-207175a0a96f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-8ae2-70ae-9550-207175a0a96f",
        "storage_key": "property/6767906449167750/01a05873-8ae2-70ae-9550-207175a0a96f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://casadecaldos.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10120985792010628771&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "casa-de-caldos",
      "poi_latitude": "45.14391699999999",
      "poi_longitude": "-122.8366435",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-902-0664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e498-74fd-b135-3cacc582564f",
        "storage_key": "property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcbmn-eddlVQRo66RXfT2dIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_1725074a-64a6-41a5-aeba-499f2cfc474a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Santa Ana Mexican Food",
      "poi_type": "Restaurants",
      "poi_address": "573 N Front St, Woodburn, OR 97071, USA",
      "poi_short_description": "Casual Mexican eatery serving up tacos (incl. breakfast) and burritos, plus staples and chips.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-8ac4-742b-870b-37d772a79c7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-8ac4-742b-870b-37d772a79c7f",
        "storage_key": "property/6767906449167750/01a05873-8ac4-742b-870b-37d772a79c7f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://santaanamexicanfoodoregon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5972926011143329278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santa-ana-mexican-food",
      "poi_latitude": "45.1438147",
      "poi_longitude": "-122.8552186",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-888-2061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e498-74fd-b135-3cacc582564f",
        "storage_key": "property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Z5eGCVclVQR_pXjq48Y5FI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b29304cc-6412-4f79-9656-bb8a2b1edd9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "La Casa De Los Machetes",
      "poi_type": "Restaurants",
      "poi_address": "445 N 1st St, Woodburn, OR 97071, USA",
      "poi_short_description": "Cozy restaurant serving Mexican comfort food including quesabirrias, machetes, and mole poblano.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-87d3-741f-9fba-7ba3509ae051.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-87d3-741f-9fba-7ba3509ae051",
        "storage_key": "property/6767906449167750/01a05873-87d3-741f-9fba-7ba3509ae051.webp",
        "width": 962,
        "height": 1024
      },
      "poi_business_url": "https://www.facebook.com/profile.php?id=100070136753247",
      "poi_directions_map_url": "https://maps.google.com/?cid=6745018131350004591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-casa-de-los-machetes",
      "poi_latitude": "45.1436614",
      "poi_longitude": "-122.8568801",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-508-8349",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e498-74fd-b135-3cacc582564f",
        "storage_key": "property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdcHmUdtdlVQRb6Ov-kAem10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_9f14e2ba-f24d-41a9-90b1-a9e8c1a56449",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Casa Marquez Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "553 N Front St, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-8ac4-742b-870b-31da366dcb9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-8ac4-742b-870b-31da366dcb9c",
        "storage_key": "property/6767906449167750/01a05873-8ac4-742b-870b-31da366dcb9c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://m.facebook.com/CasaMarquezMexicanGrill/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17748904528437611612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "casa-marquez-mexican-grill",
      "poi_latitude": "45.1436827",
      "poi_longitude": "-122.8552937",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-981-3219",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e498-74fd-b135-3cacc582564f",
        "storage_key": "property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUVFgGSVclVQRXIzYgaHGUPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_47fd1c91-2bb9-4880-b5a3-fe599b4bcf95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Lupitas Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "311 N Front St, Woodburn, OR 97071, USA",
      "poi_short_description": "Family-run spot serving burritos, churros, and other Mexican eats for dine-in or catering.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-8bac-74f8-944c-6dd61319d1ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-8bac-74f8-944c-6dd61319d1ed",
        "storage_key": "property/6767906449167750/01a05873-8bac-74f8-944c-6dd61319d1ed.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12316814871469149710&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lupitas-restaurant",
      "poi_latitude": "45.14257430000001",
      "poi_longitude": "-122.8569641",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-982-0483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e498-74fd-b135-3cacc582564f",
        "storage_key": "property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg4vDjCRclVQRDs4qSt4d7qo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_291fdf37-77a2-4217-bf4b-280fbbb01989",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Lonchera Uruapan",
      "poi_type": "Restaurants",
      "poi_address": "490 S Pacific Hwy, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-8ec5-715b-b15f-966741f6a8d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-8ec5-715b-b15f-966741f6a8d7",
        "storage_key": "property/6767906449167750/01a05873-8ec5-715b-b15f-966741f6a8d7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3622378500684319018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lonchera-uruapan",
      "poi_latitude": "45.131619",
      "poi_longitude": "-122.8479809",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-515-2820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e498-74fd-b135-3cacc582564f",
        "storage_key": "property/6767906449167750/01a05871-e498-74fd-b135-3cacc582564f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdc-xizlflVQRKglN3w1GRTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "custom_2e454652-651a-4657-b063-968ac185acad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "1560 N Pacific Hwy, Woodburn, OR 97071, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.starbucks.com/store-locator?map=45.16524,-122.89311,10z&place=Woodburn,%20OR,%20USA",
      "poi_directions_map_url": "https://maps.google.com/?cid=3146955915985961052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks",
      "poi_latitude": "45.1510434",
      "poi_longitude": "-122.8302748",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-981-2108",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c79b-7103-8e7e-e623a5c8eae4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05873-c79b-7103-8e7e-e623a5c8eae4",
        "storage_key": "property/6767906449167750/01a05873-c79b-7103-8e7e-e623a5c8eae4.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJAQA8r9FdlVQRXEAoeLs7rCs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_6a8098c7-ff43-4727-806c-caf819a04591",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Dutch Bros Coffee",
      "poi_type": "Restaurants",
      "poi_address": "1775 Mt Hood Ave, Woodburn, OR 97071, USA",
      "poi_short_description": "Fun-loving drive-thru serving up customized coffees, Rebel energy drinks, cold brew, tea & more.",
      "poi_long_description": "Fun-loving drive-thru serving up customized coffees, Rebel energy drinks, cold brew, tea & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-8e6c-72bd-ab2e-513addd61719.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-8e6c-72bd-ab2e-513addd61719",
        "storage_key": "property/6767906449167750/01a05873-8e6c-72bd-ab2e-513addd61719.webp",
        "width": 959,
        "height": 1280
      },
      "poi_business_url": "https://www.dutchbros.com/locations/or/woodburn/1775-mt.-hood-ave.?y_source=1_MTUyMjgzMDQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4366440773452738467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dutch-bros-coffee",
      "poi_latitude": "45.1515593",
      "poi_longitude": "-122.8316526",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 877-899-2767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c79b-7103-8e7e-e623a5c8eae4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05873-c79b-7103-8e7e-e623a5c8eae4",
        "storage_key": "property/6767906449167750/01a05873-c79b-7103-8e7e-e623a5c8eae4.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJR5K9uNFdlVQRo69uwr-2mDw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_2df7784d-28e5-4ca2-b1e0-98cdd3463d55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3002 Stacy Allison Way, Woodburn, OR 97071, USA",
      "poi_short_description": "Chain store selling groceries, clothes, plus home and electronics items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-90be-730a-8ea2-0cf117111e84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-90be-730a-8ea2-0cf117111e84",
        "storage_key": "property/6767906449167750/01a05873-90be-730a-8ea2-0cf117111e84.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1793-woodburn-or/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7329003662650029658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "45.1476864",
      "poi_longitude": "-122.8806768",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-981-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e43b-766e-ad6b-7eac6be6b18d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e43b-766e-ad6b-7eac6be6b18d",
        "storage_key": "property/6767906449167750/01a05871-e43b-766e-ad6b-7eac6be6b18d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJO1v-L2tclVQRWrbKHQDatWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_192e21fd-e4e5-4d1e-b22e-ae5c3acdac68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "1550 N Pacific Hwy, Woodburn, OR 97071, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05870-f6cc-77ff-bb06-ac1cea272263.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05870-f6cc-77ff-bb06-ac1cea272263",
        "storage_key": "property/6767906449167750/01a05870-f6cc-77ff-bb06-ac1cea272263.webp",
        "width": 782,
        "height": 440
      },
      "poi_business_url": "https://local.safeway.com/safeway/or/woodburn/1550-n-pacific-hwy.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=17073900609401707842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "45.1501458",
      "poi_longitude": "-122.8297092",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-982-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e496-753d-a826-78fec91b8263.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e496-753d-a826-78fec91b8263",
        "storage_key": "property/6767906449167750/01a05871-e496-753d-a826-78fec91b8263.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZd_QQidclVQRQt22kSSu8uw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e2874e79-7b7a-4c37-ac86-877ae8491938",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Mega Foods Woodburn",
      "poi_type": "Shopping & Retail",
      "poi_address": "1542 Mt Hood Ave, Woodburn, OR 97071, USA",
      "poi_short_description": "Grocery store with a full-service bakery and deli, offering a free local courtesy shuttle.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05870-fd44-759e-ae20-6a801d77ca06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05870-fd44-759e-ae20-6a801d77ca06",
        "storage_key": "property/6767906449167750/01a05870-fd44-759e-ae20-6a801d77ca06.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mymegafoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2881685401569919959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mega-foods-woodburn",
      "poi_latitude": "45.1504287",
      "poi_longitude": "-122.8363529",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-981-3735",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e496-753d-a826-78fec91b8263.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e496-753d-a826-78fec91b8263",
        "storage_key": "property/6767906449167750/01a05871-e496-753d-a826-78fec91b8263.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqbVwadJdlVQR1wMB25rN_Sc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_53488239-1e2a-4ce0-b193-461b817d5f1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Woodburn Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "1001 N Arney Rd, Woodburn, OR 97071, USA",
      "poi_short_description": "Outlet mall featuring skylight-covered walkways and more than 100 designer name-brand stores.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-058e-776c-b698-57dc06e55d18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05871-058e-776c-b698-57dc06e55d18",
        "storage_key": "property/6767906449167750/01a05871-058e-776c-b698-57dc06e55d18.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/woodburn",
      "poi_directions_map_url": "https://maps.google.com/?cid=17734731633784811681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodburn-premium-outlets",
      "poi_latitude": "45.1561674",
      "poi_longitude": "-122.8785613",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 503-980-6442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e43b-766e-ad6b-7eac6be6b18d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e43b-766e-ad6b-7eac6be6b18d",
        "storage_key": "property/6767906449167750/01a05871-e43b-766e-ad6b-7eac6be6b18d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJeeVCH0VclVQRoXCgUnVsHvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c8f07653-1934-4b7c-9667-072a42798029",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1000 Evergreen Rd, Woodburn, OR 97071, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-9517-71fd-8af4-49e4d53a2241.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-9517-71fd-8af4-49e4d53a2241",
        "storage_key": "property/6767906449167750/01a05873-9517-71fd-8af4-49e4d53a2241.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1000+n+evergreen+rd-woodburn-or-97071/id=12095",
      "poi_directions_map_url": "https://maps.google.com/?cid=9822305566508637067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "45.1515412",
      "poi_longitude": "-122.8751792",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-982-8198",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh6JxRUBclVQRi9sWN9_WT4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_ae37eb96-35fe-4df9-9299-b11bd144c32b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Woodburn Pharmacy at Woodburn Health Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1475 Mt Hood Ave Suite 100, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-9881-7022-b67e-d9d31de83dd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-9881-7022-b67e-d9d31de83dd3",
        "storage_key": "property/6767906449167750/01a05873-9881-7022-b67e-d9d31de83dd3.webp",
        "width": 690,
        "height": 358
      },
      "poi_business_url": "https://www.legacyhealth.org/doctors-and-locations/pharmacy/woodburn",
      "poi_directions_map_url": "https://maps.google.com/?cid=16034812455343975031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodburn-pharmacy-at-woodburn-health-center",
      "poi_latitude": "45.1527383",
      "poi_longitude": "-122.8363041",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 971-983-5290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c79a-7234-83b7-692889563fbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05873-c79a-7234-83b7-692889563fbe",
        "storage_key": "property/6767906449167750/01a05873-c79a-7234-83b7-692889563fbe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Z4wcupdlVQRd2rJ2PgYh94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_bf10b130-b589-425a-a208-3c73aaad815e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Carniceria El Ranchito LLC",
      "poi_type": "Shopping & Retail",
      "poi_address": "977 N Pacific Hwy, Woodburn, OR 97071, USA",
      "poi_short_description": "Grocery store with a Latin American restaurant, known for its meat.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-98e3-72e6-9f48-4d53d592811a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-98e3-72e6-9f48-4d53d592811a",
        "storage_key": "property/6767906449167750/01a05873-98e3-72e6-9f48-4d53d592811a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://carniceria-llc-woodburn.poi.place/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8482361600656878413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carniceria-el-ranchito-llc",
      "poi_latitude": "45.1438889",
      "poi_longitude": "-122.8383333",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-981-3060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e496-753d-a826-78fec91b8263.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e496-753d-a826-78fec91b8263",
        "storage_key": "property/6767906449167750/01a05871-e496-753d-a826-78fec91b8263.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe0ctCCtclVQRTSuRL-9mt3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_845ef65f-d2dd-4621-91c6-ff0076e96078",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "490 S Pacific Hwy, Woodburn, OR 97071, USA",
      "poi_short_description": "Gas station and convenience store chain offering its usual grab-and-go items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-948b-750d-a23f-e767d8e46239.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-948b-750d-a23f-e767d8e46239",
        "storage_key": "property/6767906449167750/01a05873-948b-750d-a23f-e767d8e46239.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/woodburn/490-s-pacific-hwy/2709641?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12636594415405090721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "45.131526",
      "poi_longitude": "-122.8484318",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-981-2351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c79a-7234-83b7-6f7a5828f603.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05873-c79a-7234-83b7-6f7a5828f603",
        "storage_key": "property/6767906449167750/01a05873-c79a-7234-83b7-6f7a5828f603.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJzbNNLJlelVQRocfnVKszXq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_258f41e0-a399-414f-b61c-776075c7b063",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "893 N Pacific Hwy, Woodburn, OR 97071, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-96f7-7434-ab12-1725e8a80a01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-96f7-7434-ab12-1725e8a80a01",
        "storage_key": "property/6767906449167750/01a05873-96f7-7434-ab12-1725e8a80a01.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.7-eleven.com/locations/or/woodburn/893-n-pacific-hwy-17416?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=18338281202813525806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "45.1425211",
      "poi_longitude": "-122.8395676",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-981-4774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c79a-7234-83b7-6f7a5828f603.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05873-c79a-7234-83b7-6f7a5828f603",
        "storage_key": "property/6767906449167750/01a05873-c79a-7234-83b7-6f7a5828f603.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJcXzBzCtclVQRLl_s9Jepfv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_474e2000-bbb7-48ad-beb3-e70aacba3ac9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Fruteria el Recodo",
      "poi_type": "Shopping & Retail",
      "poi_address": "1537 Mt Hood Ave Ste 106 97071, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-99c7-773f-9a90-9cc6f50b06d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-99c7-773f-9a90-9cc6f50b06d7",
        "storage_key": "property/6767906449167750/01a05873-99c7-773f-9a90-9cc6f50b06d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3709110776964248281&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fruteria-el-recodo",
      "poi_latitude": "45.152134",
      "poi_longitude": "-122.8347205",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 971-338-1268",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e43b-766e-ad6b-7eac6be6b18d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e43b-766e-ad6b-7eac6be6b18d",
        "storage_key": "property/6767906449167750/01a05871-e43b-766e-ad6b-7eac6be6b18d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEa7KlClclVQR2fKGlZloeTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_0243de69-cbdc-437e-920d-82ae5d538702",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Lincoln Elementary School",
      "poi_type": "Education",
      "poi_address": "1041 N Boones Ferry Rd, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-999e-7169-a9f6-0fd6cfe9e43c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-999e-7169-a9f6-0fd6cfe9e43c",
        "storage_key": "property/6767906449167750/01a05873-999e-7169-a9f6-0fd6cfe9e43c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lincoln.woodburnsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10224495073171802148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lincoln-elementary-school",
      "poi_latitude": "45.1514058",
      "poi_longitude": "-122.8598424",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 503-981-2825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e440-771a-adab-1d06c85eaf28",
        "storage_key": "property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyf2BcjdclVQRJAgj7Bi05I0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9bc55683-e1cd-4e57-bae0-c0c861d2c6ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "French Prairie Middle School",
      "poi_type": "Education",
      "poi_address": "1025 N Boones Ferry Rd, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://frenchprairie.woodburnsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16153301148111147602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "french-prairie-middle-school",
      "poi_latitude": "45.1501077",
      "poi_longitude": "-122.8597229",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 971-983-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e440-771a-adab-1d06c85eaf28",
        "storage_key": "property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKb7AbTdclVQRUhITc88NLOA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8bda25cc-b4df-4e3a-acab-0c396551a957",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Woodburn High School",
      "poi_type": "Education",
      "poi_address": "1785 N Front St, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-9505-754d-bddc-f868cf734629.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-9505-754d-bddc-f868cf734629",
        "storage_key": "property/6767906449167750/01a05873-9505-754d-bddc-f868cf734629.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.woodburnsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17095281894061472528&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodburn-high-school",
      "poi_latitude": "45.1533964",
      "poi_longitude": "-122.8466836",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-980-6250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e440-771a-adab-1d06c85eaf28",
        "storage_key": "property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQW4yhDRclVQREHuz1k6kPu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_96aebdb1-1d4d-4456-a2d8-85677dc16aad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Woodburn Sucess High School",
      "poi_type": "Education",
      "poi_address": "1316 Meridian Dr, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://success.woodburnsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17270425254090688052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodburn-sucess-high-school",
      "poi_latitude": "45.1512524",
      "poi_longitude": "-122.852737",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 503-980-6185",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e440-771a-adab-1d06c85eaf28",
        "storage_key": "property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS_sfHXpdlVQRNMYCFkTgrO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_880801e8-4f41-4c1e-b00e-510b245fb399",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Nellie Muir Elementary School",
      "poi_type": "Education",
      "poi_address": "1800 W Hayes St, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.woodburnsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11058292015676820050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nellie-muir-elementary-school",
      "poi_latitude": "45.1456153",
      "poi_longitude": "-122.8691487",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-982-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e440-771a-adab-1d06c85eaf28",
        "storage_key": "property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlQqJ5z1clVQRUor0uP_xdpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b2c42c86-ecbd-4c02-8f25-043bac2a10c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Washington Elementary School",
      "poi_type": "Education",
      "poi_address": "777 E Lincoln St, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://washington.woodburnsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2002678804052288530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-elementary-school",
      "poi_latitude": "45.1441296",
      "poi_longitude": "-122.8463842",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 971-983-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e440-771a-adab-1d06c85eaf28",
        "storage_key": "property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE8YN5i5clVQREqS9-sLxyhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d081da91-d180-4ed9-a168-32a2d0978303",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Heritage Elementary School",
      "poi_type": "Education",
      "poi_address": "440 Parr Rd NE, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-9684-7142-b425-9747ec7e3d6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-9684-7142-b425-9747ec7e3d6d",
        "storage_key": "property/6767906449167750/01a05873-9684-7142-b425-9747ec7e3d6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://heritage.woodburnsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16661346035433000049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heritage-elementary-school",
      "poi_latitude": "45.135123",
      "poi_longitude": "-122.87126",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-981-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e440-771a-adab-1d06c85eaf28",
        "storage_key": "property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP1IWkhxclVQRcczYkfH9OOc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9745633f-fcca-4707-8b53-cffb59dc6919",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Valor Middle School",
      "poi_type": "Education",
      "poi_address": "450 Parr Rd NE, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-9af6-72dd-856a-39a03fea8226.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-9af6-72dd-856a-39a03fea8226",
        "storage_key": "property/6767906449167750/01a05873-9af6-72dd-856a-39a03fea8226.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://valor.woodburnsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3773489240796888213&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valor-middle-school",
      "poi_latitude": "45.1352753",
      "poi_longitude": "-122.8724234",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-981-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e440-771a-adab-1d06c85eaf28",
        "storage_key": "property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP1IWkhxclVQRlfx0wXggXjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_afa2e969-afb5-4760-86cf-e3c619717d1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Chemeketa Community College Woodburn Center",
      "poi_type": "Education",
      "poi_address": "120 E Lincoln St, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-0c3f-700f-a636-3af201c9fa5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05871-0c3f-700f-a636-3af201c9fa5a",
        "storage_key": "property/6767906449167750/01a05871-0c3f-700f-a636-3af201c9fa5a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://woodburn.chemeketa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15656322088337634670&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chemeketa-community-college-woodburn-center",
      "poi_latitude": "45.1434185",
      "poi_longitude": "-122.8543206",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-584-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e440-771a-adab-1d06c85eaf28",
        "storage_key": "property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg3QpByVclVQRbnV3FP1tRtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_970ff521-9247-4708-8375-7075993880ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Woodburn Family Learning Center",
      "poi_type": "Education",
      "poi_address": "1440 Newberg Hwy, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-9cb3-774c-a957-6168efc9de36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-9cb3-774c-a957-6168efc9de36",
        "storage_key": "property/6767906449167750/01a05873-9cb3-774c-a957-6168efc9de36.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://daycarewoodburn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1720228493846212299&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodburn-family-learning-center",
      "poi_latitude": "45.1491164",
      "poi_longitude": "-122.8642507",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-981-1309",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e440-771a-adab-1d06c85eaf28",
        "storage_key": "property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXRgfEjlclVQRy241dLN63xc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_c7abe3d7-695a-4ec7-b163-747129808b3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Woodburn Historical Museum",
      "poi_type": "Entertainment",
      "poi_address": "455 N Front St, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-189a-7746-b1b6-b247d350d421.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05871-189a-7746-b1b6-b247d350d421",
        "storage_key": "property/6767906449167750/01a05871-189a-7746-b1b6-b247d350d421.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.woodburn-or.gov/museum?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=3ad9f244-0419-48be-95cc-6f59ca082183",
      "poi_directions_map_url": "https://maps.google.com/?cid=6442253209276930323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodburn-historical-museum",
      "poi_latitude": "45.143227",
      "poi_longitude": "-122.855935",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 971-446-1441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e4f5-742a-a778-b45c0f93af8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e4f5-742a-a778-b45c0f93af8a",
        "storage_key": "property/6767906449167750/01a05871-e4f5-742a-a778-b45c0f93af8a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJA-555CRclVQRE1kSTCl7Z1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b4e64407-4907-496c-9257-56a62b5a528f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "K-Bron Brewing Co",
      "poi_type": "Restaurants",
      "poi_address": "237 N Front St, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-9f24-77ab-a007-9c687ce9282a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-9f24-77ab-a007-9c687ce9282a",
        "storage_key": "property/6767906449167750/01a05873-9f24-77ab-a007-9c687ce9282a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://k-bronbrewingcompany0805.s4shops.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4153460967548008871&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "k-bron-brewing-co",
      "poi_latitude": "45.14203260000001",
      "poi_longitude": "-122.8573532",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-902-0063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c7c9-77eb-8337-5bb68fb61b3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05873-c7c9-77eb-8337-5bb68fb61b3f",
        "storage_key": "property/6767906449167750/01a05873-c7c9-77eb-8337-5bb68fb61b3f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJza4ZD0RdlVQRpzkmd74OpDk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_2fefa87e-b98b-45a3-aa65-6354169da24c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "The Oregon Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "879 W Main St, Silverton, OR 97381, USA",
      "poi_short_description": "Cozy rooms with fireplaces in a Frank Lloyd Wright-designed hotel set in a botanical garden.",
      "poi_long_description": "Cozy rooms with fireplaces in a Frank Lloyd Wright-designed hotel set in a botanical garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-9cc1-735e-9b8a-152712eeb2ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-9cc1-735e-9b8a-152712eeb2ed",
        "storage_key": "property/6767906449167750/01a05873-9cc1-735e-9b8a-152712eeb2ed.webp",
        "width": 1280,
        "height": 846
      },
      "poi_business_url": "http://www.oregongarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8041950590625160754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-oregon-garden",
      "poi_latitude": "44.9950179",
      "poi_longitude": "-122.7885873",
      "poi_miles_from_property": "15.8",
      "poi_walking_minutes": "5 hours 46 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 503-874-4294",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd0dQVnnjv1QRMp50P3S_mm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_4972d169-4253-43bc-a246-265cf7406a04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Enchanted Forest",
      "poi_type": "Entertainment",
      "poi_address": "8462 Enchanted Way SE, Turner, OR 97392, USA",
      "poi_short_description": "Long-standing children's theme park featuring classic rides & storybook-inspired attractions.",
      "poi_long_description": "Long-standing children's theme park featuring classic rides & storybook-inspired attractions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-9e02-767c-b0c8-d370e346a594.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-9e02-767c-b0c8-d370e346a594",
        "storage_key": "property/6767906449167750/01a05873-9e02-767c-b0c8-d370e346a594.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.enchantedforest.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11310391501878656992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enchanted-forest",
      "poi_latitude": "44.8313064",
      "poi_longitude": "-123.0089874",
      "poi_miles_from_property": "26.5",
      "poi_walking_minutes": "9 hours 49 mins",
      "poi_biking_minutes": "2 hours 37 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 503-371-4242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe79BX4AIwFQR4P8SXCWV9pw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_5add1524-7fc9-411e-b868-1d17d3ebb4d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Regal Willamette Town Center",
      "poi_type": "Entertainment",
      "poi_address": "831 Lancaster Dr NE #8, Salem, OR 97301, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-9e7d-7399-b0e6-f3e684b07db3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-9e7d-7399-b0e6-f3e684b07db3",
        "storage_key": "property/6767906449167750/01a05873-9e7d-7399-b0e6-f3e684b07db3.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-willamette-town-center-0679?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8282726553783696953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-willamette-town-center",
      "poi_latitude": "44.9425974",
      "poi_longitude": "-122.9876072",
      "poi_miles_from_property": "17.2",
      "poi_walking_minutes": "6 hours 16 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c7c8-7755-9709-706310e011e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05873-c7c8-7755-9709-706310e011e7",
        "storage_key": "property/6767906449167750/01a05873-c7c8-7755-9709-706310e011e7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJyyMIgsT-v1QROf74ueon8nI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_5b6fe8fb-3cc7-44ad-9d6d-d6112584d153",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Grand Theater",
      "poi_type": "Entertainment",
      "poi_address": "187 High St NE, Salem, OR 97301, USA",
      "poi_short_description": "Theater, cinema and event space featuring films, plays, musicals and local bands.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-a4b2-762f-8b9d-0890ac476c97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-a4b2-762f-8b9d-0890ac476c97",
        "storage_key": "property/6767906449167750/01a05873-a4b2-762f-8b9d-0890ac476c97.webp",
        "width": 1280,
        "height": 1117
      },
      "poi_business_url": "http://salemshg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9171126061326842696&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grand-theater",
      "poi_latitude": "44.9406022",
      "poi_longitude": "-123.0371393",
      "poi_miles_from_property": "18.1",
      "poi_walking_minutes": "6 hours 36 mins",
      "poi_biking_minutes": "1 hour 43 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 503-362-9185",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwdQsXA3_v1QRSLu2449iRn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_9335e969-174f-4650-a9fc-613c2cf7fce4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Elsinore Theatre",
      "poi_type": "Entertainment",
      "poi_address": "170 High St SE, Salem, OR 97301, USA",
      "poi_short_description": "Music & live-theater venue in a 1926 former movie house with Gothic stylings & a 1,534-pipe organ.",
      "poi_long_description": "Music & live-theater venue in a 1926 former movie house with Gothic stylings & a 1,534-pipe organ.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-9edc-7298-90d2-4304d3e28fd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-9edc-7298-90d2-4304d3e28fd4",
        "storage_key": "property/6767906449167750/01a05873-9edc-7298-90d2-4304d3e28fd4.webp",
        "width": 1000,
        "height": 664
      },
      "poi_business_url": "http://elsinoretheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2987231666418540748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elsinore-theatre",
      "poi_latitude": "44.9389172",
      "poi_longitude": "-123.0373483",
      "poi_miles_from_property": "18.2",
      "poi_walking_minutes": "6 hours 39 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 503-375-3574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSyXSm3_v1QRzOCsol_HdCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_72101f44-66df-40c4-a394-6c8f16b48e9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Willamette Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "1313 Mill St SE, Salem, OR 97301, USA",
      "poi_short_description": "Victorian-era, water-powered mill turned wool-making museum, with exhibits, a cafe & shops.",
      "poi_long_description": "Victorian-era, water-powered mill turned wool-making museum, with exhibits, a cafe & shops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-a31a-762e-93de-a672a7ee9ffd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-a31a-762e-93de-a672a7ee9ffd",
        "storage_key": "property/6767906449167750/01a05873-a31a-762e-93de-a672a7ee9ffd.webp",
        "width": 1280,
        "height": 669
      },
      "poi_business_url": "http://www.willametteheritage.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=774131211214114254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willamette-heritage-center",
      "poi_latitude": "44.93439009999999",
      "poi_longitude": "-123.0268261",
      "poi_miles_from_property": "18.3",
      "poi_walking_minutes": "6 hours 41 mins",
      "poi_biking_minutes": "1 hour 47 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 503-585-7012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e4f5-742a-a778-b45c0f93af8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e4f5-742a-a778-b45c0f93af8a",
        "storage_key": "property/6767906449167750/01a05871-e4f5-742a-a778-b45c0f93af8a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1flivhX_v1QRzs31LTxEvgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_3fdb5d6e-3ee0-4545-ad0e-08eec4595b8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Salem's Riverfront Carousel",
      "poi_type": "Entertainment",
      "poi_address": "101 Front St NE, Salem, OR 97301, USA",
      "poi_short_description": "Local volunteers carved more than 40 horses by hand for this indoor carousel, which opened in 2001.",
      "poi_long_description": "Local volunteers carved more than 40 horses by hand for this indoor carousel, which opened in 2001.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-afac-774e-ab1a-42573161c721.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-afac-774e-ab1a-42573161c721",
        "storage_key": "property/6767906449167750/01a05873-afac-774e-ab1a-42573161c721.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.salemcarousel.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17101151948747463013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salems-riverfront-carousel",
      "poi_latitude": "44.9410879",
      "poi_longitude": "-123.0430662",
      "poi_miles_from_property": "18.4",
      "poi_walking_minutes": "6 hours 43 mins",
      "poi_biking_minutes": "1 hour 42 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 503-540-0374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuWiQGnP_v1QRZVkScxd_U-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b3545d0e-75f9-4e68-a0d8-384376fe8180",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "North American Aerospace Museum",
      "poi_type": "Entertainment",
      "poi_address": "500 NE Captain Michael King Smith Way, McMinnville, OR 97128, USA",
      "poi_short_description": "Home to several historic aircraft, including the world's largest, plus a water park & 3D theater.",
      "poi_long_description": "Home to several historic aircraft, including the world's largest, plus a water park & 3D theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-a427-7588-9d83-749e469de4de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-a427-7588-9d83-749e469de4de",
        "storage_key": "property/6767906449167750/01a05873-a427-7588-9d83-749e469de4de.webp",
        "width": 1280,
        "height": 1008
      },
      "poi_business_url": "http://www.noramaerospace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14958905982325145340&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-american-aerospace-museum",
      "poi_latitude": "45.204304",
      "poi_longitude": "-123.14543",
      "poi_miles_from_property": "25.8",
      "poi_walking_minutes": "9 hours 20 mins",
      "poi_biking_minutes": "2 hours 12 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 503-434-4180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e4f5-742a-a778-b45c0f93af8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e4f5-742a-a778-b45c0f93af8a",
        "storage_key": "property/6767906449167750/01a05871-e4f5-742a-a778-b45c0f93af8a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9RfTK1JPlVQR_L70OLy1mM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ce65150b-b38e-4284-b294-48cf784718b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Legacy Silverton Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "342 Fairview St, Silverton, OR 97381, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-a583-763b-9d20-d15effd98a24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-a583-763b-9d20-d15effd98a24",
        "storage_key": "property/6767906449167750/01a05873-a583-763b-9d20-d15effd98a24.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://www.legacyhealth.org/doctors-and-locations/hospitals/legacy-silverton-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=3669974017237679381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legacy-silverton-medical-center",
      "poi_latitude": "45.00460899999999",
      "poi_longitude": "-122.7900209",
      "poi_miles_from_property": "14.8",
      "poi_walking_minutes": "5 hours 25 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 503-873-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVCjHJzjv1QRFX1doOxd7jI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_143e2014-de4f-47d5-a2a1-8034c67bf1b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Salem Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "890 Oak St SE Bldg a, Salem, OR 97301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-a5e3-70d9-8593-6283d2743ddd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-a5e3-70d9-8593-6283d2743ddd",
        "storage_key": "property/6767906449167750/01a05873-a5e3-70d9-8593-6283d2743ddd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.salemhealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2213863693941847053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salem-hospital",
      "poi_latitude": "44.9325948",
      "poi_longitude": "-123.0342173",
      "poi_miles_from_property": "18.5",
      "poi_walking_minutes": "6 hours 46 mins",
      "poi_biking_minutes": "1 hour 45 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 503-561-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e496-753d-a826-76ed78ee39b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e496-753d-a826-76ed78ee39b3",
        "storage_key": "property/6767906449167750/01a05871-e496-753d-a826-76ed78ee39b3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTQ9W2r_v1QRDbSJ0kw5uR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_eb03ff40-9047-4e59-ab22-9b52d513856b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Legacy Urgent Care-Woodburn",
      "poi_type": "Health and Wellness",
      "poi_address": "1475 Mt Hood Ave Ste 110, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-a944-766b-a9b0-f4fbfab08a30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-a944-766b-a9b0-f4fbfab08a30",
        "storage_key": "property/6767906449167750/01a05873-a944-766b-a9b0-f4fbfab08a30.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://www.legacyhealth.org/doctors-and-locations/urgent-care/legacy-woodburn",
      "poi_directions_map_url": "https://maps.google.com/?cid=15489419349349250074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legacy-urgent-care-woodburn",
      "poi_latitude": "45.1524606",
      "poi_longitude": "-122.8356524",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 971-983-5360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjwHt4M1dlVQRGjQG79R49dY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_ece22b61-43b3-4f85-8370-e0e9d127c35a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Salem Health Urgent Care — Woodburn",
      "poi_type": "Health and Wellness",
      "poi_address": "105 N Arney Rd #130, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-aa28-777c-ae88-9669f0fc9f42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-aa28-777c-ae88-9669f0fc9f42",
        "storage_key": "property/6767906449167750/01a05873-aa28-777c-ae88-9669f0fc9f42.webp",
        "width": 1280,
        "height": 829
      },
      "poi_business_url": "https://www.salemhealth.org/services/family-medicine/woodburn-clinic",
      "poi_directions_map_url": "https://maps.google.com/?cid=18350257546544913227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salem-health-urgent-care--woodburn",
      "poi_latitude": "45.15199820000001",
      "poi_longitude": "-122.8856949",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-902-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4zvF2VNdlVQRS5u9xgM2qf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_baccfe16-6273-4550-9e80-50c1a771493b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Legacy Medical Group-Woodburn Health Center - a department of Legacy Silverton Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1475 Mt Hood Ave Ste 120, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-aba4-745b-be7e-93c51e604c03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-aba4-745b-be7e-93c51e604c03",
        "storage_key": "property/6767906449167750/01a05873-aba4-745b-be7e-93c51e604c03.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.legacyhealth.org/doctors-and-locations/primary/woodburn-health-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=3955323153219816458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legacy-medical-group-woodburn-health-center---a-department-of-legacy-silverton-medical-center",
      "poi_latitude": "45.15286529999999",
      "poi_longitude": "-122.8363285",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-982-2174",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjwHt4M1dlVQRCoyLn3Mh5DY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_a4d2e99d-bb2d-4788-89cb-8a058489e254",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3002 Stacy Allison Way, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-a9b3-7469-b6e4-5751974dcdb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-a9b3-7469-b6e4-5751974dcdb2",
        "storage_key": "property/6767906449167750/01a05873-a9b3-7469-b6e4-5751974dcdb2.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/1793-woodburn-or/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=15272582826932065178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "45.1480002",
      "poi_longitude": "-122.8807111",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-981-9625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c79a-7234-83b7-692889563fbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05873-c79a-7234-83b7-692889563fbe",
        "storage_key": "property/6767906449167750/01a05873-c79a-7234-83b7-692889563fbe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO1v-L2tclVQRmlME2ikd89M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_88d681b1-f843-482f-a62c-95579df0a135",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Burn Fitness 24/7",
      "poi_type": "Health and Wellness",
      "poi_address": "1755 Mt Hood Ave #130, Woodburn, OR 97071, USA",
      "poi_short_description": "Spacious gym featuring weightlifting gear, cardio equipment and group classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-bf85-73b5-8624-9ec48a319667.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-bf85-73b5-8624-9ec48a319667",
        "storage_key": "property/6767906449167750/01a05873-bf85-73b5-8624-9ec48a319667.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.myburnfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10882153576924885345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burn-fitness-247",
      "poi_latitude": "45.1525688",
      "poi_longitude": "-122.8313293",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-980-9050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx0xH1nNdlVQRYbHapwUtBZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_80f153d1-1b6a-43c4-a296-b61974d7693c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2247 Country Club Rd, Woodburn, OR 97071, USA",
      "poi_short_description": "Gym offering 24/7 access, personal training, and group workouts, plus free trials.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-21f9-711b-b02b-9d9a5297ec51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05871-21f9-711b-b02b-9d9a5297ec51",
        "storage_key": "property/6767906449167750/01a05871-21f9-711b-b02b-9d9a5297ec51.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/woodburn-oregon-1439/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=1439",
      "poi_directions_map_url": "https://maps.google.com/?cid=17954889562411451342&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "45.1524928",
      "poi_longitude": "-122.8748127",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-984-0423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCRODIUFclVQRzkPnjO2ULPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cfa718fc-5683-498f-91aa-73524f366937",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Silver Falls Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "601 Miller St, Silverton, OR 97381, USA",
      "poi_short_description": "Outdoor and indoor public pool featuring lanes, kiddie areas, diving boards and swim lessons.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-b001-718e-9c9e-be526ffd991c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-b001-718e-9c9e-be526ffd991c",
        "storage_key": "property/6767906449167750/01a05873-b001-718e-9c9e-be526ffd991c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://theyonline.org/locations/silver-falls-family-ymca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6593852548300335443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "silver-falls-family-ymca",
      "poi_latitude": "45.0010943",
      "poi_longitude": "-122.7810725",
      "poi_miles_from_property": "15",
      "poi_walking_minutes": "5 hours 28 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 503-873-6456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW7zG5ITjv1QRU-m--vQRgls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "swimming_pool"
    },
    {
      "id": "custom_fe789cac-9baf-405a-8a9b-591c48015e80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Centennial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "900 Parr Rd NE, Woodburn, OR 97071, USA",
      "poi_short_description": "Kid-friendly park with playground equipment, soccer fields and a splash pad for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-5f02-718a-adb0-166cd70905b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05871-5f02-718a-adb0-166cd70905b7",
        "storage_key": "property/6767906449167750/01a05871-5f02-718a-adb0-166cd70905b7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12217572462828470066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-park",
      "poi_latitude": "45.1330995",
      "poi_longitude": "-122.8755487",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-982-5264",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e7bb-71d9-9088-869c44a5d1e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e7bb-71d9-9088-869c44a5d1e8",
        "storage_key": "property/6767906449167750/01a05871-e7bb-71d9-9088-869c44a5d1e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2yUsqQRclVQRMj98aGyJjak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2a564941-b907-4530-acd3-0402c5d22343",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Legion Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1385 Park Ave, Woodburn, OR 97071, USA",
      "poi_short_description": "Park with a playground, picnic area, basketball and pickleball courts, and a paved walking trail.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-5dd8-7496-9ce4-967f933fb53a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05871-5dd8-7496-9ce4-967f933fb53a",
        "storage_key": "property/6767906449167750/01a05871-5dd8-7496-9ce4-967f933fb53a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.woodburn-or.gov/parks/page/legion-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1534371789131416585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legion-park",
      "poi_latitude": "45.1480732",
      "poi_longitude": "-122.8422784",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-982-5240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e7bb-71d9-9088-869c44a5d1e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e7bb-71d9-9088-869c44a5d1e8",
        "storage_key": "property/6767906449167750/01a05871-e7bb-71d9-9088-869c44a5d1e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrebicy1clVQRCQSPRAMvSxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c5cebace-a771-44ac-b281-f917d52bdf5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Settlemier Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "400 S Settlemier Ave, Woodburn, OR 97071, USA",
      "poi_short_description": "Park featuring a skate park, a playground and picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-68bf-737d-996a-754e182621bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05871-68bf-737d-996a-754e182621bf",
        "storage_key": "property/6767906449167750/01a05871-68bf-737d-996a-754e182621bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.woodburn-or.gov/parks/page/settlemier-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8573212995186813275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "settlemier-park",
      "poi_latitude": "45.1403431",
      "poi_longitude": "-122.8612537",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-982-5222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e7bb-71d9-9088-869c44a5d1e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e7bb-71d9-9088-869c44a5d1e8",
        "storage_key": "property/6767906449167750/01a05871-e7bb-71d9-9088-869c44a5d1e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEVD1UCJclVQRW2nf2csr-nY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_303fd9be-d1cf-4fbb-b8c9-1b1b283f0c1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Woodburn Downtown Plaza",
      "poi_type": "Entertainment",
      "poi_address": "N 1st St, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-172f-7398-97e4-55a3cad8e9a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05871-172f-7398-97e4-55a3cad8e9a2",
        "storage_key": "property/6767906449167750/01a05871-172f-7398-97e4-55a3cad8e9a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14290654656710628364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodburn-downtown-plaza",
      "poi_latitude": "45.1429118",
      "poi_longitude": "-122.8570489",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDA7CRclVQRDNQE9bGaUsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_355c7b6c-3701-4c53-92ce-2acffdca448f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Hermanson Pond",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "875 Hermanson St, Woodburn, OR 97071, USA",
      "poi_short_description": "Quaint park featuring a pond, walking trails and a bench for bird-watching.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-b1a4-74be-826f-eeb4586e7049.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-b1a4-74be-826f-eeb4586e7049",
        "storage_key": "property/6767906449167750/01a05873-b1a4-74be-826f-eeb4586e7049.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5662433281218902345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hermanson-pond",
      "poi_latitude": "45.1323782",
      "poi_longitude": "-122.8538445",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c7c8-7755-9709-6db1b4fbff3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05873-c7c8-7755-9709-6db1b4fbff3d",
        "storage_key": "property/6767906449167750/01a05873-c7c8-7755-9709-6db1b4fbff3d.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJGwK2tZ9elVQRSflmgxEBlU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_1510385e-7e7e-4c4d-a6ad-b902d7f63df4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Alvah Cowan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "620 Garfield St, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1445919424730056885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alvah-cowan-park",
      "poi_latitude": "45.1446443",
      "poi_longitude": "-122.8609094",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e7bb-71d9-9088-869c44a5d1e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e7bb-71d9-9088-869c44a5d1e8",
        "storage_key": "property/6767906449167750/01a05871-e7bb-71d9-9088-869c44a5d1e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qaXTtclVQRtUjfVA7wEBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6c494f86-bf36-49c7-96fc-db6b0abe0058",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Historic SP1785 Locomotive",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "S Front St &, E Cleveland St, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-bdf5-7515-ad72-62f5f20761e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-bdf5-7515-ad72-62f5f20761e9",
        "storage_key": "property/6767906449167750/01a05873-bdf5-7515-ad72-62f5f20761e9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.woodburn-or.gov/parks/page/historic-1785-locomotive",
      "poi_directions_map_url": "https://maps.google.com/?cid=5508307677576199351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "historic-sp1785-locomotive",
      "poi_latitude": "45.1410955",
      "poi_longitude": "-122.8575215",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-982-5266",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e7bb-71d9-9088-869c44a5d1e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e7bb-71d9-9088-869c44a5d1e8",
        "storage_key": "property/6767906449167750/01a05871-e7bb-71d9-9088-869c44a5d1e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJhRfbsIBdlVQRt3x8A6ZwcUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0f21cfb0-8633-44a3-a526-ebacffac30f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "North Front Street Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1080 N Front St, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-b3de-759f-8cd1-b74f95f854b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-b3de-759f-8cd1-b74f95f854b4",
        "storage_key": "property/6767906449167750/01a05873-b3de-759f-8cd1-b74f95f854b4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.woodburn-or.gov/?q=parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=13135945438395489322&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-front-street-park",
      "poi_latitude": "45.14714720000001",
      "poi_longitude": "-122.8515156",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-982-5264",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e7bb-71d9-9088-869c44a5d1e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e7bb-71d9-9088-869c44a5d1e8",
        "storage_key": "property/6767906449167750/01a05871-e7bb-71d9-9088-869c44a5d1e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-89rMzBclVQRKtx5bMdATLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6f7ebda2-faaf-46d5-a0c7-df54d95584da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Burlingham Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3350 Linda St, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17644847942575992271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burlingham-park",
      "poi_latitude": "45.1559234",
      "poi_longitude": "-122.8872745",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e7bb-71d9-9088-869c44a5d1e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e7bb-71d9-9088-869c44a5d1e8",
        "storage_key": "property/6767906449167750/01a05871-e7bb-71d9-9088-869c44a5d1e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVV4GdclVQRzy0GpbcX3_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6614352b-252d-48ea-8859-926b2aaa7f26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "2900 Tom Tennant Dr, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.njtransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7406045490862364098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "transit-center",
      "poi_latitude": "45.1513169",
      "poi_longitude": "-122.8772405",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c7da-72cb-a675-691d5f9b9b7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05873-c7da-72cb-a675-691d5f9b9b7c",
        "storage_key": "property/6767906449167750/01a05873-c7da-72cb-a675-691d5f9b9b7c.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_70ykFclVQRwhU8kSKPx2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_bd84e53c-c4af-468c-bb92-7de28d217dc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Greyhound: Bus Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "2875 Newberg Hwy, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-b3d6-726d-a2b6-75e8e3f5f9b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-b3d6-726d-a2b6-75e8e3f5f9b6",
        "storage_key": "property/6767906449167750/01a05873-b3d6-726d-a2b6-75e8e3f5f9b6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/woodburn-or/woodburn-transit-center?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=1582603948691113990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-stop",
      "poi_latitude": "45.1515772",
      "poi_longitude": "-122.8763149",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu2oy4iRclVQRBkjdBeiJ9hU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_a354154b-e71d-4448-b455-fb4ac06b5521",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Woodburn Transit Center - 1st @ Arthur",
      "poi_type": "Transportation & Transit",
      "poi_address": "Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-b309-7234-bac4-784d3bdb9878.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-b309-7234-bac4-784d3bdb9878",
        "storage_key": "property/6767906449167750/01a05873-b309-7234-bac4-784d3bdb9878.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1901513423384874862&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodburn-transit-center---1st--arthur",
      "poi_latitude": "45.1423825",
      "poi_longitude": "-122.8578892",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c7c9-77eb-8337-5c7b3fdb0992.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05873-c7c9-77eb-8337-5c7b3fdb0992",
        "storage_key": "property/6767906449167750/01a05873-c7c9-77eb-8337-5c7b3fdb0992.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ46qjhSRclVQRbg9-SGKIYxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_39a10125-7bd7-42d6-a7b5-dfca446a10b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Salem Amtrak",
      "poi_type": "Transportation & Transit",
      "poi_address": "555 13th St SE, Salem, OR 97301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-b57e-721b-b85a-84de04b1bbaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-b57e-721b-b85a-84de04b1bbaf",
        "storage_key": "property/6767906449167750/01a05873-b57e-721b-b85a-84de04b1bbaf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/stations/slm",
      "poi_directions_map_url": "https://maps.google.com/?cid=9700197782570496712&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salem-amtrak",
      "poi_latitude": "44.9324066",
      "poi_longitude": "-123.0282179",
      "poi_miles_from_property": "18.4",
      "poi_walking_minutes": "6 hours 44 mins",
      "poi_biking_minutes": "1 hour 48 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrTlWWhX_v1QRyHIlSX0GnoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_3dfc5f24-d5ad-44df-ab11-f46db48357a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Portland International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7000 NE Airport Way, Portland, OR 97218, USA",
      "poi_short_description": "Hub featuring direct rail service to Downtown, plus works by regional artists & frequent live music.",
      "poi_long_description": "Hub featuring direct rail service to Downtown, plus works by regional artists & frequent live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-b310-72f4-a3b1-77b5a2a1c788.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-b310-72f4-a3b1-77b5a2a1c788",
        "storage_key": "property/6767906449167750/01a05873-b310-72f4-a3b1-77b5a2a1c788.webp",
        "width": 1000,
        "height": 668
      },
      "poi_business_url": "https://www.flypdx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6618732977047100477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "portland-international-airport",
      "poi_latitude": "45.5852698",
      "poi_longitude": "-122.5917184",
      "poi_miles_from_property": "41.5",
      "poi_walking_minutes": "15 hours 18 mins",
      "poi_biking_minutes": "4 hours 0 mins",
      "poi_driving_minutes": "51 mins",
      "poi_business_phone": "+1 503-460-4234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c79b-7103-8e7e-e8dc895a18a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05873-c79b-7103-8e7e-e8dc895a18a6",
        "storage_key": "property/6767906449167750/01a05873-c79b-7103-8e7e-e8dc895a18a6.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0SDcdKqglVQRPVwOOJN22ls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_352f0d93-4ef9-4850-a221-3ef3af444ecc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Keizer Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5680 Chemawa Way NE, Keizer, OR 97303, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-b6e7-706a-82d6-112f345d1ae0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-b6e7-706a-82d6-112f345d1ae0",
        "storage_key": "property/6767906449167750/01a05873-b6e7-706a-82d6-112f345d1ae0.webp",
        "width": 783,
        "height": 1280
      },
      "poi_business_url": "https://www.cherriots.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11696701401509692952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "keizer-transit-center",
      "poi_latitude": "45.0069875",
      "poi_longitude": "-123.0023128",
      "poi_miles_from_property": "13.7",
      "poi_walking_minutes": "4 hours 57 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 888-275-6368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c7da-72cb-a675-691d5f9b9b7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05873-c7da-72cb-a675-691d5f9b9b7c",
        "storage_key": "property/6767906449167750/01a05873-c7da-72cb-a675-691d5f9b9b7c.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJowoYHANWlVQRGIbM8PMHU6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_6504b8b8-7f02-4a90-bc89-1d592809f813",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Wilsonville Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "9699 SW Barber St, Wilsonville, OR 97070, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-b75a-7518-8553-6eb692edb920.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-b75a-7518-8553-6eb692edb920",
        "storage_key": "property/6767906449167750/01a05873-b75a-7518-8553-6eb692edb920.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ridesmart.com/transit/page/wilsonville-transit-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=8292288715551228446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilsonville-transit-center",
      "poi_latitude": "45.3108285",
      "poi_longitude": "-122.7753601",
      "poi_miles_from_property": "23",
      "poi_walking_minutes": "8 hours 31 mins",
      "poi_biking_minutes": "2 hours 9 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 503-682-7790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWSt7YJVvlVQRHkJpAacgFHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_ecc94000-ffa9-410d-8eb2-d266a93f5b87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "WinCo Foods Distribution Center Truck Entrance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 S Woodland Ave, Woodburn, OR 97071, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-b896-742b-96fc-2fd208097cc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-b896-742b-96fc-2fd208097cc1",
        "storage_key": "property/6767906449167750/01a05873-b896-742b-96fc-2fd208097cc1.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13495302059968103859&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winco-foods-distribution-center-truck-entrance",
      "poi_latitude": "45.1470479",
      "poi_longitude": "-122.88643",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-982-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8UdEXG1clVQRswX_7LjxSLs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supplier"
    },
    {
      "id": "custom_5fd4acb6-8738-4375-aa72-0a70a8571533",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Woodburn School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1390 Meridian Dr, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-b8db-74ce-bea7-b5c8716f1346.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-b8db-74ce-bea7-b5c8716f1346",
        "storage_key": "property/6767906449167750/01a05873-b8db-74ce-bea7-b5c8716f1346.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.woodburnsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1773782975238095578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodburn-school-district",
      "poi_latitude": "45.1515438",
      "poi_longitude": "-122.8536035",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 503-981-7640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e440-771a-adab-1d06c85eaf28",
        "storage_key": "property/6767906449167750/01a05871-e440-771a-adab-1d06c85eaf28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqzg9-SlclVQR2sKz0ze-nRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c01fe8fc-674b-4068-9389-5cd71f312430",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Kerr Contractors",
      "poi_type": "Major Employers & Offices",
      "poi_address": "395 Shenandoah Ln NE, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-bd2d-7304-8b4c-d45d4f9e9d97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-bd2d-7304-8b4c-d45d4f9e9d97",
        "storage_key": "property/6767906449167750/01a05873-bd2d-7304-8b4c-d45d4f9e9d97.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.kerrcontractors.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6000727219988717082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kerr-contractors",
      "poi_latitude": "45.16181030000001",
      "poi_longitude": "-122.8382041",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 971-216-0050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO5695LddlVQRGt5xBZ3dRlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_contractor"
    },
    {
      "id": "custom_30bb1c51-9058-4dc6-a909-01079f4f0913",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Woodburn City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "270 Montgomery St, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.woodburn-or.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8895417013637294876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodburn-city-hall",
      "poi_latitude": "45.1421979",
      "poi_longitude": "-122.8594038",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-982-5222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e8f0-76e8-a14e-0286ce97d957.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e8f0-76e8-a14e-0286ce97d957",
        "storage_key": "property/6767906449167750/01a05871-e8f0-76e8-a14e-0286ce97d957.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu7A9fSNclVQRHCvR2qTecns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_6613716f-d30e-4aca-afc5-0ca343315c3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "Woodburn Police Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1060 Mt Hood Ave, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-bc63-74ae-a0e4-a33fc58af0d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-bc63-74ae-a0e4-a33fc58af0d8",
        "storage_key": "property/6767906449167750/01a05873-bc63-74ae-a0e4-a33fc58af0d8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4762836836209834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodburn-police-department",
      "poi_latitude": "45.1513011",
      "poi_longitude": "-122.8431305",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-982-2345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c7d2-7520-a778-f2a320a5b712.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05873-c7d2-7520-a778-f2a320a5b712",
        "storage_key": "property/6767906449167750/01a05873-c7d2-7520-a778-f2a320a5b712.webp",
        "width": 177,
        "height": 192
      },
      "poi_google_place_id": "ChIJu7A9fSNclVQRqtS-XcbrEAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_aee65075-c8df-479e-ad4a-d8780bbaa0a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "BrucePac",
      "poi_type": "Shopping & Retail",
      "poi_address": "380 S Pacific Hwy, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-bf37-75a1-a324-28d3a9a7f173.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-bf37-75a1-a324-28d3a9a7f173",
        "storage_key": "property/6767906449167750/01a05873-bf37-75a1-a324-28d3a9a7f173.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brucepac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17160898618071596877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brucepac",
      "poi_latitude": "45.1331352",
      "poi_longitude": "-122.84259",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-874-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e43b-766e-ad6b-7eac6be6b18d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e43b-766e-ad6b-7eac6be6b18d",
        "storage_key": "property/6767906449167750/01a05871-e43b-766e-ad6b-7eac6be6b18d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgwgMsptelVQRTT-m7F7CJ-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_store"
    },
    {
      "id": "custom_7c58ba08-f833-420f-bf6c-aeec7a3321d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "United Pacific Forest Products",
      "poi_type": "Transportation & Transit",
      "poi_address": "2550 Progress Way, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c1a5-74b9-a36c-b001f40c8bb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-c1a5-74b9-a36c-b001f40c8bb0",
        "storage_key": "property/6767906449167750/01a05873-c1a5-74b9-a36c-b001f40c8bb0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.upfp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2992065045103389813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-pacific-forest-products",
      "poi_latitude": "45.155486",
      "poi_longitude": "-122.8342309",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-982-4018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3fBlGs9dlVQRdSxATk7zhSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_eb87527d-967f-4f40-bbb8-b0c51ca751d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "US Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "350 S Pacific Hwy, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05873-c060-764c-bfa6-4b35572df19e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a05873-c060-764c-bfa6-4b35572df19e",
        "storage_key": "property/6767906449167750/01a05873-c060-764c-bfa6-4b35572df19e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.usfoods.com/locations/restaurant-supplier-in-woodburn--oregon.html?utm_medium=organic&utm_source=google_business_profile&utm_campaign=woodburn_or",
      "poi_directions_map_url": "https://maps.google.com/?cid=18325440794803140015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-foods",
      "poi_latitude": "45.1309498",
      "poi_longitude": "-122.8447441",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-980-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e449-7328-8fc9-c585a4df62d1",
        "storage_key": "property/6767906449167750/01a05871-e449-7328-8fc9-c585a4df62d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL0Vec5lelVQRr3Wxfk8LUf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wholesaler"
    },
    {
      "id": "custom_474accfc-330f-4f25-bc42-6bff7405a7a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "custom",
      "poi_name": "MacLaren Youth Correctional Facility",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2630 N Pacific Hwy, Woodburn, OR 97071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.oregon.gov/oya/pages/facilities/maclaren.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6486637093938652233&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maclaren-youth-correctional-facility",
      "poi_latitude": "45.15602",
      "poi_longitude": "-122.8200465",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-981-9531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-e8f0-76e8-a14e-0286ce97d957.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a05871-e8f0-76e8-a14e-0286ce97d957",
        "storage_key": "property/6767906449167750/01a05871-e8f0-76e8-a14e-0286ce97d957.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJY06UcJdlVQRSeQVuxEqBVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    }
  ],
  "office_hours": [
    {
      "id": "ec_aab669d5e1cec7cacf8346dd",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_0402b20c400b931c6e70bc9e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f4d9296f44bebc10b68401c9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5c810ff4bd54f9eab75b499a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_a0d264fa4b0cb9d9752fa2b3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "rating": "5",
      "name": "Diana Brown",
      "text": "I would recommend Tilian Point  Apartments to anyone looking to move to Woodburn. My daughter and grandchildren live there and I have visited many times. The location is great! They are walking distance to the Woodburn Outlet Mall ans just a minute or so from the freeway.\n\nThe complex has many nice amenities such as an outdoor barbecue area, a  clubhouse, hammocks,  cozy swinging  chairs, a workout room  even have planters boxes!\n\nI love that they have EV charging stations for my electric car at an adorable price. I live in Oregon City so always  need a charge after getting there.\n\nMy daughter has a three bedroom and it  modern and bright inside. Her kitchen has plenty of cabinets, a decent size living room,  spacious bedrooms and bathrooms.\n\nWe have used the clubhouse a couple of times for parties and we had many compliments on the room.  It’s a nicely decorated clubhouse with plenty of room for entertaining.",
      "date": "2025-11-07",
      "title": "false"
    },
    {
      "id": "ec_3523213c7d339e30d5a60dcd",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "rating": "5",
      "name": "Maria Soto",
      "text": "The apartments are beautiful and spacious. The amenities are very nice and the price is affordable. Location is great. And last but not least Hannah D. was a pleasure to work with she performed and assisted us with the move with great tact. I appreciate her help very much. Can't wait until this new place is settled in and we make it our home.",
      "date": "2024-12-02",
      "title": "false"
    },
    {
      "id": "ec_905dab9b13f7a4ca147683b5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "rating": "5",
      "name": "Myranda Valencia",
      "text": "I came in for a tour and was welcomed by Hannah, the property manager who was very helpful and knowledgeable. I am new to the process of apartment shopping and she answered all my questions, she was very kind and patient with me. The apartment community was very nice and Hannah was a pleasure to deal with!",
      "date": "2025-11-07",
      "title": "false"
    },
    {
      "id": "ec_c9a4445555a4ad44c7d8ce78",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "rating": "5",
      "name": "Wilma Karsten",
      "text": "Love my brand new apt.love the walking trail in back of the blogs. There is one of the lights out on the back trail behind bldng B about half way down. Hannah is a great manager and is on top of everything. Thank you for the opportunity to live in this wonderful property. Have a very merry Christmas and a happy new year",
      "date": "2024-12-05",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_47fed74e94121afb88b380c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-176e-71bb-ba3f-05766cca8a10.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a05871-176e-71bb-ba3f-05766cca8a10",
        "storage_key": "property/6767906449167750/01a05871-176e-71bb-ba3f-05766cca8a10.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Tilian Point - 3 Bedroom - Unit B312",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3nHVbzeSe9C"
    },
    {
      "id": "ec_4a6157efdb3521635f9f5377",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-1327-707c-aae2-db0add7cb98b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a05871-1327-707c-aae2-db0add7cb98b",
        "storage_key": "property/6767906449167750/01a05871-1327-707c-aae2-db0add7cb98b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Tilian Point - 1 Bedroom - Unit A304",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=fD6365iWGrh"
    },
    {
      "id": "ec_6b6c54bd1c45100bfc37c357",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167750/01a05871-12e4-75da-baa1-13bb40f59eb6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a05871-12e4-75da-baa1-13bb40f59eb6",
        "storage_key": "property/6767906449167750/01a05871-12e4-75da-baa1-13bb40f59eb6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Tilian Point - 360 Amenities Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=1eozsh91fMn"
    }
  ],
  "faqs": [
    {
      "id": "custom_d4202504-64f1-4059-9009-711f0c220145",
      "question": "How much is the application fee?",
      "answer": "At Tilian Point our application fee is $45 per adult applicant 18 years or older.",
      "category": "Overview",
      "source": "custom"
    },
    {
      "id": "custom_77ada8a8-8a5d-48f4-93d8-0796862d72fb",
      "question": "What types of apartments are available at Tilian Point?",
      "answer": "Tilian Point offers 1-, 2-, and 3-bedroom apartments in Woodburn, Oregon. All homes include an in-home washer and dryer, stainless steel appliances, granite countertops, and a private patio or balcony.",
      "category": "Overview",
      "source": "custom"
    },
    {
      "id": "custom_6cf4b91e-c5fb-4534-a10b-a9a1438dc6d4",
      "question": "Where is Tilian Point located?",
      "answer": "We are located at 2385 Sprague Lane in Woodburn, Oregon 97071. Woodburn Premium Outlets is directly across the street, and I-5 is just a few minutes away at Exit 271.",
      "category": "Overview",
      "source": "custom"
    },
    {
      "id": "custom_49b7a8a5-dba8-43d1-94e9-56eab1b2ae39",
      "question": "Does Tilian Point allow pets?",
      "answer": "Yes! Tilian Point is a pet-friendly community. We allow up to 2 pets per home. A $500 deposit is required for the first pet and $300 for a second, plus $35 per month per pet. Breed restrictions apply. Assistance animals and service animals are always welcome with no fees or deposits required, per Fair Housing guidelines.",
      "category": "Overview",
      "source": "custom"
    },
    {
      "id": "custom_9164c6a0-a407-44a1-b57a-e184279bfce1",
      "question": "Do the apartments include a washer and dryer?",
      "answer": "Yes. Every apartment at Tilian Point comes with an in-home washer and dryer — no shared laundry rooms, no trips to the laundromat.",
      "category": "Overview",
      "source": "custom"
    },
    {
      "id": "custom_6fcaf8b7-c440-46a9-8175-36f837b72308",
      "question": "How close is Tilian Point to Portland?",
      "answer": "Tilian Point is approximately 38 miles from Downtown Portland via I-5 North — about a 38-minute drive in normal traffic. I-5 access is just minutes from our front door at Exit 271.",
      "category": "Overview",
      "source": "custom"
    },
    {
      "id": "custom_1337b297-e0d4-48d4-b7df-c3277030b89b",
      "question": "¿Hablan español en Tilian Point? / Is Spanish-speaking staff available?",
      "answer": "Sí, ofrecemos asistencia en español. Llámenos al (971) 432-8392 o visiten nuestra oficina. / Yes, we offer assistance in Spanish. Call (971) 432-8392 or stop by the leasing office.",
      "category": "Overview",
      "source": "custom"
    },
    {
      "id": "custom_cdc51228-c350-477e-9e07-79e7ef0575c4",
      "question": "What floor plans are available at Tilian Point?",
      "answer": "Visit the floorplans page to see pricing and availability.",
      "category": "Floor Plans",
      "source": "custom"
    },
    {
      "id": "custom_8781a68d-43f2-45c6-9d6d-930a8ab5795b",
      "question": "Do all apartments have a washer and dryer?",
      "answer": "Yes. Every apartment at Tilian Point includes a full-size in-home washer and dryer — no shared laundry facilities needed.",
      "category": "Floor Plans",
      "source": "custom"
    },
    {
      "id": "custom_80080c42-4ed2-4fff-a721-2729d57c3157",
      "question": "Do the apartments have a patio or balcony?",
      "answer": "Yes. Every home at Tilian Point includes a private patio or balcony. It’s a great place to relax and enjoy the outdoors from the comfort of your own home.",
      "category": "Floor Plans",
      "source": "custom"
    },
    {
      "id": "custom_d6eec82c-4aac-4849-bcfb-0eac1030c9e2",
      "question": "Are there apartments with vaulted ceilings or a built-in desk?",
      "answer": "Yes, select apartments at Tilian Point feature vaulted ceilings, a stand-up shower and tub, or a built-in desk. These features are not available in all units. Contact our leasing team to ask about specific layouts.",
      "category": "Floor Plans",
      "source": "custom"
    },
    {
      "id": "custom_3282f254-da1b-4d8c-a0b6-ce0a2a285158",
      "question": "Is Tilian Point pet-friendly?",
      "answer": "Yes. Tilian Point is a pet-friendly community allowing up to 2 pets per home. A deposit and monthly pet rent apply. Breed restrictions apply. Assistance animals are exempt from all pet fees per Fair Housing guidelines. See our Amenities page for full pet policy details.",
      "category": "Floor Plans",
      "source": "custom"
    },
    {
      "id": "custom_1ccab124-721d-4df2-93b9-0cb2ecd4f520",
      "question": "How many bedrooms are available?",
      "answer": "We offer 1-, 2-, and 3-bedroom apartments. Call (971) 432-8392 to ask about availability.",
      "category": "Floor Plans",
      "source": "custom"
    },
    {
      "id": "custom_d5384e28-a38f-4dd7-afd0-9dec0a07f0ab",
      "question": "Is there a gym at Tilian Point?",
      "answer": "Yes. Tilian Point has a fully equipped on-site fitness center with cardio machines and free weights, available to all residents.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_66c5a59a-aa48-4d75-ab65-5fbb76c1f3da",
      "question": "Does Tilian Point have a dog park?",
      "answer": "Yes. We have an on-site dog park. We allow up to 2 pets per home. Pet deposits and monthly pet rent apply. Assistance animals are exempt from all pet fees per Fair Housing guidelines.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_a5b967b1-1fbf-43bf-ac90-43eb81632ccd",
      "question": "What is the pet deposit at Tilian Point?",
      "answer": "The pet deposit is $500 for one pet and $300 for a second pet. Monthly pet rent is $35 per pet. Breed restrictions apply. Service and assistance animals are not subject to pet fees or deposits.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_82e31c1b-a24b-4694-8ff4-30346c5414cd",
      "question": "Can I pay rent online?",
      "answer": "Yes. Tilian Point offers online rent payments for all residents. Contact our leasing team for setup details.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_7e3fe654-18a5-4a64-aa59-93151dfb34fc",
      "question": "Is there parking at Tilian Point?",
      "answer": "Yes. Carport parking is available for residents. Contact the leasing office for current availability and pricing.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_9e4ebf4a-cd23-41a8-bf87-4adbabc3f370",
      "question": "Does Tilian Point have a pool?",
      "answer": "Tilian Point does not have a pool, but offers a hammock lounge, fire pit, outdoor grill, and dog park. Contact our team or schedule a tour to see all our outdoor spaces in person.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_7915905d-3624-4c0f-8e3a-c94e1b789491",
      "question": "How far is Tilian Point from Downtown Portland?",
      "answer": "Tilian Point is approximately 38 miles from Downtown Portland via I-5 North — about a 38-minute drive in normal traffic. I-5 access is 3 minutes from our front door at Exit 271.",
      "category": "Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_0c7ec13d-8b7d-4bd8-99fc-50da4924f5ec",
      "question": "What grocery stores are near Tilian Point?",
      "answer": "Walmart Supercenter is about 1 mile away and Safeway is approximately 1.5 miles from Tilian Point. Both are an easy short drive from the community.",
      "category": "Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_2ee09291-945b-480a-b5df-3a171b508f43",
      "question": "Are there parks near Tilian Point?",
      "answer": "Yes. Centennial Park is just 0.3 miles away with sports fields, open space, and a playground. Heritage Park is also nearby with walking paths and picnic areas.",
      "category": "Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_8be024df-cb43-492e-affa-b682e03ff38d",
      "question": "Is Tilian Point close to schools?",
      "answer": "Yes. Tilian Point is located within the Woodburn School District, which includes bilingual programs and Spanish-language services. Contact the Woodburn School District directly for enrollment information and school assignments based on your address.",
      "category": "Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_0aa26e41-291f-4292-ab11-1ddcb625aac3",
      "question": "Is there public transportation near Tilian Point?",
      "answer": "Woodburn is served by Cherriots Regional transit with connections to Salem and the broader region. I-5 at Exit 271 is 3 minutes away for car commuters. Contact our leasing office for the most current transit information.",
      "category": "Neighborhood",
      "source": "custom"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0f47a-ebf0-70df-be7a-d7e5e7dffec4",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750"
    },
    {
      "lead_collector_id": "01a0f822-c6a9-741f-996f-463a543956bd",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Tilian Point Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750"
    },
    {
      "lead_collector_id": "01a0f822-d83d-7068-a80d-2c14eb3d5f55",
      "lead_source": "LANDING_PAGE",
      "name": "Tilian Point Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "generator",
      "page_item_url": "luxury-apartments-dog-park-woodburn-or",
      "search_query": "luxury apartments with dog park in Woodburn OR",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Dog Park",
      "h2_subtitle": "Discover luxury living in Woodburn, OR. Enjoy premium amenities, including a dog park, ideal for pet lovers.",
      "page_copy": "Explore Tilian Point, a standout choice for luxury apartments with a dog park in Woodburn OR. Nestled in a serene area of Marion County, Tilian Point offers high-end amenities designed for comfort and convenience. \n\nOur exclusive dog park is perfect for pet enthusiasts. Beyond pet-friendly spaces, residents enjoy a comprehensive fitness center, a restful hammock lounge, and courts catered to basketball and pickleball aficionados. With in-home washer & dryers, Tilian Point redefines luxury living in Woodburn with its perfect blend of style and functionality.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Dog Park",
      "seo_description": "Explore luxury living at Tilian Point in Woodburn, OR, featuring amenities like a dedicated dog park. Ideal for pet lovers seeking premium lifestyles.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "generator",
      "page_item_url": "basketball-pickleball-court-tilian-point-woodburn",
      "search_query": "basketball and pickleball court at Tilian Point Woodburn",
      "category": "Amenity",
      "h1_title": "Basketball & Pickleball Courts at Tilian Point",
      "h2_subtitle": "Embrace an active lifestyle at Tilian Point in Woodburn. Experience top-notch basketball and pickleball courts right at your doorstep.",
      "page_copy": "At Tilian Point, we offer more than just apartments; we provide an active community. Our basketball and pickleball courts are perfect settings for both seasoned players and beginners looking to enjoy these sports in Woodburn, OR. Active living is at the heart of our philosophy.\n\nLocated in beautiful Marion County, residents can relish in the convenience of premium on-site amenities, such as our fitness center and hammock lounge. And don't forget, our in-home washer and dryers ensure that post-game cleanups are a breeze. Choose Tilian Point for a lifestyle that combines leisure and fitness seamlessly.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Basketball & Pickleball Courts at Tilian Point",
      "seo_description": "Play basketball or pickleball at Tilian Point Woodburn. Enjoy an active lifestyle with premium amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "generator",
      "page_item_url": "apartments-in-home-washer-dryer-marion-county",
      "search_query": "apartments with in-home washer and dryer Marion County",
      "category": "Amenity",
      "h1_title": "Apartments with In-Home Washer & Dryer",
      "h2_subtitle": "Enjoy modern convenience in Marion County. Our apartments include in-home washer and dryer units for hassle-free living.",
      "page_copy": "Tilian Point offers premium apartments with in-home washer and dryer facilities in Marion County. Located in Woodburn, OR, our community prioritizes convenience and comfort. Say goodbye to laundromat visits, as each apartment is equipped with top-tier washers and dryers.\n\nAt Tilian Point, residents enjoy a blend of luxury and practicality. Beyond laundry amenities, indulge in our state-of-the-art fitness center, dog park, and tranquil hammock lounge. Discover the benefits of a community designed with all your lifestyle needs in mind, from active days on the basketball and pickleball courts to relaxing evenings at home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Home Washer & Dryer",
      "seo_description": "Discover Marion County living at Tilian Point with in-home washer and dryer amenities, offering ultimate convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "generator",
      "page_item_url": "fitness-center-gym-apartments-woodburn-or",
      "search_query": "fitness center and gym apartments in Woodburn OR",
      "category": "Amenity",
      "h1_title": "Fitness Center Gym Apartments in Woodburn",
      "h2_subtitle": "Elevate your lifestyle with our premium fitness center. Enjoy top-tier gym facilities at Tilian Point in Woodburn, OR.",
      "page_copy": "Tilian Point, nestled in the charming city of Woodburn, OR, offers apartments with access to a cutting-edge fitness center. Aimed at active individuals, our gym is equipped with everything you need to maintain a healthy lifestyle without leaving home.\n\nOur commitment to wellness extends beyond the gym. After a great workout, relax in our hammock lounge or take your furry friends for a romp at our dog park. Whether you're hitting the courts for basketball and pickleball or washing up with in-home washers and dryers, Tilian Point ensures every facet of your lifestyle is catered to with style and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Gym Apartments in Woodburn",
      "seo_description": "Experience top-notch gym facilities at Tilian Point, Woodburn OR, offering a great fitness center and other luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "generator",
      "page_item_url": "private-patio-balcony-apartment-woodburn",
      "search_query": "private patio or balcony apartment in Woodburn",
      "category": "Amenity",
      "h1_title": "Private Patio or Balcony Apartments",
      "h2_subtitle": "Experience serene outdoor moments with private patios or balconies. Discover this exclusive feature at Tilian Point in Woodburn.",
      "page_copy": "At Tilian Point in Woodburn, OR, each apartment is designed with your privacy and enjoyment in mind, featuring private patios or balconies. These outdoor spaces allow residents to unwind with a morning coffee or relax under the stars, offering a personal retreat right outside your door.\n\nOur community is tailored to suit diverse lifestyle needs, boasting amenities such as a state-of-the-art fitness center and a fun-filled dog park. Enjoy the luxury of in-home washers and dryers, and explore recreation options with our basketball and pickleball courts. Choose Tilian Point for a tranquil and active living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Private Patio or Balcony Apartments",
      "seo_description": "Enjoy private patios or balconies at Tilian Point in Woodburn, offering serene outdoor spaces and top-tier amenities for a relaxed lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-woodburn-or",
      "search_query": "one bedroom apartments in Woodburn OR",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Woodburn",
      "h2_subtitle": "Discover comfortable one-bedroom apartments at Tilian Point. Perfectly located in Woodburn, OR, for convenient and modern living.",
      "page_copy": "Tilian Point offers stylish one-bedroom apartments in the heart of Woodburn, OR. Our thoughtfully designed spaces provide the perfect blend of comfort and convenience, ideal for singles or couples looking to enjoy modern living.\n\nEach apartment comes with in-home washers and dryers, ensuring hassle-free laundry days. Residents can take advantage of our state-of-the-art fitness center, enjoy outdoor activities at our dog park, or unwind at the hammock lounge. With amenities like basketball and pickleball courts, there's always something to do. Experience a vibrant, welcoming community at Tilian Point.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Woodburn",
      "seo_description": "Explore Tilian Point's one-bedroom apartments in Woodburn, OR, offering modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-marion-county",
      "search_query": "two bedroom apartments Marion County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Marion County",
      "h2_subtitle": "Tilian Point offers spacious two-bedroom apartments in Marion County. Enjoy modern amenities and a vibrant community lifestyle.",
      "page_copy": "Located in the charming setting of Marion County, Tilian Point provides spacious two-bedroom apartments designed for comfortable living. These homes are perfect for families or roommates seeking a tranquil retreat with ample space.\n\nResidents enjoy the convenience of in-home washers and dryers, making laundry hassle-free. Engage in an active lifestyle with our on-site fitness center and unwind in our community dog park. Get competitive on our basketball and pickleball courts or relax at the hammock lounge. At Tilian Point, experience the perfect blend of serenity and activity.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Marion County",
      "seo_description": "Discover Tilian Point's two-bedroom apartments in Marion County. Enjoy spacious living with top-notch amenities and community features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-97071",
      "search_query": "three bedroom apartments near 97071",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 97071",
      "h2_subtitle": "Explore spacious three-bedroom apartments close to the 97071 area. Discover the perfect blend of comfort and convenience at Tilian Point.",
      "page_copy": "Tilian Point, located conveniently near the 97071 area, offers expansive three-bedroom apartments ideal for families or those needing extra space. These well-designed homes provide the perfect environment for relaxation and entertaining guests.\n\nResidents enjoy in-home washers and dryers, ensuring laundry days are straightforward and efficient. The community boasts a variety of amenities, including a modern fitness center, a dog park for pet lovers, and sports facilities like basketball and pickleball courts. Join us at Tilian Point and enjoy both a vibrant community atmosphere and personal tranquility.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 97071",
      "seo_description": "Find spacious three-bedroom apartments at Tilian Point near the 97071 area, offering top amenities and a warm community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "generator",
      "page_item_url": "apartments-near-chemeketa-community-college",
      "search_query": "apartments near Chemeketa Community College Woodburn Center in Marion County",
      "category": "School",
      "h1_title": "Apartments Near Chemeketa College Woodburn",
      "h2_subtitle": "Discover convenient living near Chemeketa Community College Woodburn Center. Tilian Point offers the ideal home base in Marion County.",
      "page_copy": "For those seeking a convenient residence near Chemeketa Community College Woodburn Center, Tilian Point is the perfect choice. Located in Marion County, our apartments offer the ideal blend of comfort and accessibility, making them a prime option for students and faculty alike.\n\nOur community features amenities that enhance everyday living, from in-home washers and dryers ensuring ease of chores, to a fitness center catering to active lifestyles. Residents can relax in the hammock lounge or enjoy a game of basketball or pickleball. Move into Tilian Point and gain a supportive community environment just minutes away from campus.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Chemeketa College Woodburn",
      "seo_description": "Find perfect apartments near Chemeketa Community College Woodburn Center at Tilian Point with easy access and modern amenities in Marion County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "generator",
      "page_item_url": "apartments-near-saint-louis-fish-ponds-park",
      "search_query": "apartments near Saint Louis Fish Ponds County Park Woodburn",
      "category": "Park",
      "h1_title": "Apartments Near Saint Louis Fish Ponds Park",
      "h2_subtitle": "Live near Saint Louis Fish Ponds County Park in Woodburn. Tilian Point offers a serene setting with top-notch amenities.",
      "page_copy": "Nestled close to Saint Louis Fish Ponds County Park in Woodburn, Tilian Point provides the perfect home base for nature enthusiasts and park-goers. Our vibrant community in Marion County is ideal for those who love the outdoors and seek a comfortable living environment.\n\nResidents enjoy modern conveniences like in-home washers and dryers, making everyday tasks simple and efficient. The community also features a fully-equipped fitness center, a dog park for furry friends, and recreational facilities including basketball and pickleball courts. Live at Tilian Point and experience the balance of nature and modern living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saint Louis Fish Ponds Park",
      "seo_description": "Discover comfortable apartments near Saint Louis Fish Ponds County Park in Woodburn at Tilian Point with excellent amenities in Marion County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "generator",
      "page_item_url": "apartments-close-to-legion-park-or",
      "search_query": "apartments close to Legion Park OR",
      "category": "Park",
      "h1_title": "Apartments Close to Legion Park, OR",
      "h2_subtitle": "Experience living near Legion Park in Woodburn, OR. Tilian Point offers spacious apartments with great amenities.",
      "page_copy": "Tilian Point offers the perfect location for those wanting to be close to Legion Park in Woodburn, OR. Our community is designed for residents who appreciate easy access to outdoor recreation and city conveniences.\n\nEnjoy the comfort of our spacious apartments equipped with in-home washers and dryers. Our community features a state-of-the-art fitness center, a dog park, and lounges like the hammock area, making it a perfect abode for relaxation and socializing. Come and find your home at Tilian Point, where convenience and lifestyle meet near Legion Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Legion Park, OR",
      "seo_description": "Live near Legion Park, OR at Tilian Point. Enjoy modern living with top amenities and easy park access in Woodburn, OR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "generator",
      "page_item_url": "apartments-near-centennial-park-97071",
      "search_query": "apartments near Centennial Park 97071",
      "category": "Park",
      "h1_title": "Apartments Near Centennial Park, 97071",
      "h2_subtitle": "Discover prime apartments near Centennial Park in 97071. Tilian Point offers a community filled with modern amenities and natural beauty.",
      "page_copy": "Situated conveniently near Centennial Park, Tilian Point provides an ideal home for those drawn to the beauty of Woodburn's local attractions. Located in the 97071 area, our apartments are perfect for anyone who enjoys being close to parks and nature.\n\nChoose from a variety of spacious floor plans, each equipped with in-home washers and dryers to simplify day-to-day chores. Residents benefit from an array of amenities, including a full fitness center, a dog park, and outdoor spaces like our hammock lounge. With recreational courts and a welcoming community, Tilian Point is the best choice for living near Centennial Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Centennial Park, 97071",
      "seo_description": "Find ideal apartments near Centennial Park, 97071 at Tilian Point. Enjoy modern amenities and a great location in Woodburn.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162471",
      "property_id": "6767906449167750",
      "source": "generator",
      "page_item_url": "apartments-close-to-settlemier-park-marion-county",
      "search_query": "apartments close to Settlemier Park Marion County",
      "category": "Park",
      "h1_title": "Apartments Close to Settlemier Park",
      "h2_subtitle": "Live near Settlemier Park in Marion County. Enjoy the best of Woodburn living at Tilian Point with excellent amenities.",
      "page_copy": "Tilian Point is ideally located for those wanting to live close to Settlemier Park in Marion County. Our community offers the perfect blend of convenience and tranquility, making it ideal for anyone who appreciates park-side living.\n\nAt Tilian Point, residents have access to a wide range of amenities. Each apartment features a convenient in-home washer and dryer, making laundry a breeze. For those who love staying active, our fitness center and sports courts provide excellent recreational opportunities. With a dog park and relaxing hammock lounge, settling into life near Settlemier Park has never been easier.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Settlemier Park",
      "seo_description": "Discover apartments close to Settlemier Park in Marion County at Tilian Point, offering great amenities and a prime location in Woodburn.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12935705039"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W8G7VVKF"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Homestead"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/yjp242xevxl"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "5417483199"
    }
  ],
  "custom_repli_id": "12935705039",
  "custom_google_gtm_id": "GTM-W8G7VVKF",
  "custom_vibesites_theme": "Homestead",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/yjp242xevxl",
  "custom_ppc_tracking_phone_number": "5417483199"
};

export const generatedAt = '2026-10-01T16:13:25.943Z';
